import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

import { UsageService } from "../services/usage-service";
import { NotifyService } from "../services/notify-service";
import { ContractService } from "../services/contract-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EventService } from "../services/event-service";
import { ModalService } from "../services/modal-service";
import { AclService } from "../services/acl-service";
import { BulkAmountsModalController } from "./bulk-create-amounts";
import { AdminService } from "../services/admin-service";
import { DateCalcService } from "../services/date-calc-service";
import { SearchService } from "../services/search-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { WorkflowService } from "../services/workflow-service";
import { EntityService } from "../services/entity-service";
import { AssetService } from "../services/asset-service";
import { IMetaDataFilter } from "../filters/chardata-filter";
import * as angular from "angular";
import { IOnApplyFiltersEvent } from "../components/list-column-filter.component";
import { AdminConfigService } from "../services/admin-config-service";

enum BulkCreateAction {
    Number = 0,
    CatalogItems = 1,
    SelectedCatalogItems = 2
}

export function RLUsages() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/usages.html"),
        controllerAs: "uVM",
        controller: UsagesController,
        scope: {
            temporaryContractRecId: "=?",
            entityId: "@",
            parentCurrencyCharData: "=",
            locked: "=",
            groupedSelectedAmounts: "=?",
            forceRefresh: "=?",
            relCharTypeId: '=?',
            relChildCharTypeId: '=?',
            relEntityId: "=?",
            newlyCreatedUsageEntityIds: "=?",
            canEdit: '=?',
            templatesCharTypeId: '@',
            templatesTemplateId: '@',
            templatesGroupId: '@',
            intersectionTemplates: '=',
            hideCreateButton: '=?',
            totalUsagesCnt: '=?',
            showFinancials: '<'
        },
        bindToController: true,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: UsagesController) => { }
    }

    return directive;
}

enum BulkAssociationMode {
    Replace = 0,
    Add = 1,
    Remove = 2
}

export class UsagesController {
    static $inject = [
        "$scope",
        "$rootScope",
        "$window",
        "$q",
        "$timeout",
        "$filter",
        "$interval",
        "$uibModal",
        "simpleCache",
        "usageService",
        "assetService",
        "notifyService",
        "contractService",
        "entityService",
        "entityConfigService",
        "workflowService",
        "workflowConfigService",
        "searchService",
        "dateCalcService",
        "eventService",
        "adminService",
        'modalService',
        "aclService",
        "adminConfigService"
    ];

    initialized = false;
    hideCreateButton: boolean;
    isBulkCreateMode: boolean = false;
    temporaryContractRecId: number;
    entityId: string = null;
    parentRecordID: number;
    charTypeID: number;
    relCharTypeId: number;
    relChildCharTypeId: number;
    relEntityId: string;

    parentCurrencyCharData: Models.ICharDataValue;
    removedComponentTriples: Models.IRemovedComponentTriple[] = [];
    orphanedCatalogItems: Models.IChildNotExistingParentEntityRelationshipList[];
    uniqueCatalogItemTemplates: number[];
    usageRows: {
        [templateID: number]: Models.IUsageRow[]
    };

    selectedRows: { [templateID: number]: Models.IUsageRow[] } = {};
    selectedUsages: { [templateID: number]: Models.IUsageDocument[] } = {};
    selectedUsageIDs: { [templateID: string]: string[] } = {};
    usageWorkflowActions: { [templateID: number]: Models.IWFAction[] } = {};
    amountWorkflowActions: Models.IWFAction[] = [];

    visibility: number = 1;
    allSelected: { [templateID: number]: boolean } = {};
    toggleSelected: { [templateID: number]: boolean } = {};

    usageTableCollection: Models.IUsageTableCollection;
    groupPages: { [templateID: number]: { page: number, pageCount: number, rowCount: number, numFound: number, sortDir?: number, sortField?: string } } = {};
    openGroups: { [templateID: number]: boolean } = [];
    forceRefresh: boolean = false;

    expandedUsages: { [recID: number]: Models.IUsageRow } = {};
    openEntities: { [id: number]: any } = [];
    usageCurrencyCharDatas: { [usageID: number]: Models.ICharDataValue } = {};

    usageTemplateHasSelectedAmounts: { [templateID: string]: boolean } = {};
    groupedSelectedAmounts: { [usageID: string]: Models.IEntitySearchDoc[]; } = {};
    selectedAmounts: Models.IEntitySearchDoc[] = [];

    amountTemplates: { [key: number]: Models.ICharacteristicTemplate[] } = {};
    catalogTemplates: { [key: number]: Models.ICharacteristicTemplate[] } = {};

    copyOrMoveAllowMultiSelect: boolean = false;
    copyOrMoveUsageModalOpen: boolean = false;
    copyOrMoveModalTitle: string;
    copyOrMoveSelectedUsages: Models.IUsageDocument[];
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[] = [];
    copyOrMoveTemplateGroupIDs: number[] = [];
    copyOrMoveParentCharTypeID: number;
    copyOrMoveChildCharTypeID: number;
    copyOrMoveParentTemplateID: number;
    copyOrMoveDirection: number = 0;
    copyOrMoveIsCopy: boolean = false;
    copyOrMoveParentEntityID: string;
    copyOrMoveChildEntityID: string;
    copyOrMoveDateMathWarning: string;
    copyOrMoveNewEntityID: string;
    charDataIDsAndNames: Models.ICharacteristicType[];

    deleteCatalogItemModalOpen: boolean = false;
    deleteCatalogItemEntityTitle: string;
    deleteCatalogItemCatalogListText: string;
    deleteCatalogItemParentCharTypeName: string;

    bulkEditAssociationsModalOpen: boolean;
    bulkExistingRelationships: Models.IEntityRelationship[];
    bulkUsageData: Models.IUsageRelationshipPair[];
    bulkCatalogAssociationMode: BulkAssociationMode = BulkAssociationMode.Replace;
    bulkUsagesTemplateID: number;
    bulkCatalogItems: Models.IEntitySearchDoc[] = [];

    locked: number;

    selectedEntities: Models.IEntity[];
    selectedProjectEntities: Models.IEntity[];

    usageTemplates: { [templateID: number]: Models.ICharDataCollection };
    usageHasAssets: { [templateID: number]: boolean } = {};
    showAssets: boolean = true;

    usageHasProjects: { [templateID: number]: boolean } = {};
    usageHasContacts: { [templateID: number]: boolean } = {};
    usageHasMocks: { [templateID: number]: boolean } = {};

    usageParentRecs: { [templateID: number]: Models.IEntityID } = {};
    usageParentRels: { [templateID: number]: number } = {};

    searchModel: Models.IAdvancedSearchModel = {
        charTypeID: Consts.CharTypeIDs.usage,
        searchGroups: [],
        keywords: '',
        rowCount: 10,
        page: 1,
        relatedEntityID: this.entityId,
        groups: ['template'],
        sortField: 'table_sequence',
        sortDir: 0
    };
    numFound: number;
    newlyCreatedUsageEntityIds: string[] = [];

    templates: Models.ICharacteristicTemplate[];

    filterValues: { [templateID: number]: { [solrLabel: string]: string[] } } = {};
    selectedFilters: { [templateID: number]: { [tagLabel: string]: { [value: string]: boolean } } } = {};
    tagLabelFilters: { [templateID: number]: { [solrLabel: string]: string[] } } = {};
    filtersEnabled: { [templateID: number]: boolean } = {};
    filterDropdownOpen: boolean = false;
    filterRemovedAll: { [templateID: number]: boolean } = {};
    filterTemplateIDAndUsagesHeaderRow: { [templateID: number]: Models.IUsageRow } = {};
    catalogItemKeywords: { [templateID: number]: string } = {};

    csvExportJobID: string;
    csvExportProgressIntervalPromise: ng.IPromise<any>;
    showJobProgressStatus: boolean = false;
    jobId: string = "";
    jobTitle: string = "";
    jobTemplateID: number;
    jobType: string;
    progressStatus: string;
    canBulkDelete: { [templateID: number]: boolean } = {};
    hasLockedRowsSelected: { [templateID: string]: boolean } = {};
    hasLockedAmountsSelected: { [templateID: string]: boolean } = {};
    hasAmountAssociatedToAcctDocument: { [templateID: string]: boolean } = {};

    amountWorkflowConfig: Models.IWFProcessConfig[];

    bulkTableCreateOpen: boolean;
    numberAction = BulkCreateAction.Number;
    catalogAction = BulkCreateAction.CatalogItems;
    selectedCatalogAction = BulkCreateAction.SelectedCatalogItems;

    refreshTableParent: boolean = false;

    allowableChidrenCharTypesOfTables: number[];
    canCreate: boolean = false;
    totalUsagesCnt: number = 0;

    bulkDeleteTemplateID: number;
    bulkDeleteGroupPages: { page: number, pageCount: number, rowCount: number, numFound: number, sortDir?: number, sortField?: string };
    bulkEditTemplateID: number;
    bulkCreatedAmountIDs: string[];
    bulkCreateAction: number = BulkCreateAction.Number;
    bulkCreateNumber: number = 1;
    bulkCreateTemplateID: number;

    usageTemplateDefaults: Models.ITemplateDefaults;
    associatedTemplates: Models.ICharacteristicTemplate[];
    templatesCharTypeId: number;
    templatesTemplateId: string;
    templatesGroupId: number;
    intersectionTemplates: Models.ICharacteristicTemplate[];
    catalogSearchAction: boolean = false;

    //Drag and Drop
    sortableOptions: any = {
        containment: '#usages-table',
        containerPositioning: 'relative',
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$parent.$parent.template.$$hashKey === destSortableScope.$parent.$parent.template.$$hashKey;
        },
        orderChanged: (event) => {
            this.UpdateUsageOrder(event);
        }
    };

    notifications: Models.IWFNotificationWithAttachments[] = [];
    selectedProcessID: number;
    selectedCharTypeID: number;
    selectedTemplateID: number;
    selectedRecIDs: number[] = [];
    selectedActionID: number;
    showEditNotification: boolean = false;
    selectedNotification: Models.IWFNotificationWithAttachments;
    editNotificationView: number;
    isBusyProcessingModalAction: boolean = false;

    assets: string[] = [];

    // Pivot Rows
    pivotRows: {
        [templateID: number]: {
            [relRecID: number]: {
                [date: string]: number
            }
        }
    } = [];
    expandedPivot: { [templateID: number]: boolean } = [];
    datesOrdered: { [templateID: number]: string[] } = [];
    dateTotals: { [templateID: number]: { [date: string]: number } } = [];
    templateTotal: { [templateID: number]: { currency: string, amount: number } } = [];
    canTemplatePivot: { [templateID: number]: boolean } = [];
    isTemplatePivoted: { [templateID: number]: boolean } = [];

    showFinancials: boolean;
    templatesAllowedOnFinancialTab: number[] = [Consts.SystemIndicators.Amortization, Consts.SystemIndicators.Allocation];
    templatesAllowedEverywhere: number[] = [Consts.SystemIndicators.PaymentSchedule];
    amortizationFeeTagLabel: string;
    allocationTemplateID: number;
    usageTemplateHasCatalogOrProjectOrContactOrMockRelConfigured: { [templateID: number]: boolean } = {};
    currentPreviewEntityID: string;
    isLoading: boolean = false;
    deferrals: { [key: string]: ng.IDeferred<Models.ICharacteristicTemplate[]> } = {};
    selectCatalogItemsForBulkTableCreateOptionOpen: boolean;
    selectedRelatedCatalogItemsForBulkCreateUsage: _.Dictionary<Models.IEntitySearchDoc[]> = {};
    workflowTemplateID: number;

    amountCatalogRels: { [key: number]: Models.IEntityRecIDTitle } = {};
    amountCatalogRelationships: { [entityID: string]: Models.IEntityRelationship[] } = {};

    public constructor(
        private readonly scope: ng.IScope,
        private readonly $rootScope: ng.IRootScopeService,
        private readonly $window: ng.IWindowService,
        private readonly $q: ng.IQService,
        private readonly $timeout: ng.ITimeoutService,
        private readonly $filter: ng.IFilterService,
        private readonly $interval: ng.IIntervalService,
        private readonly $uibModal: ng.ui.bootstrap.IModalService,
        private readonly simpleCache: ng.ICacheObject,
        private readonly usageService: UsageService,
        private readonly assetService: AssetService,
        private readonly notifyService: NotifyService,
        private readonly contractService: ContractService,
        private readonly entityService: EntityService,
        private readonly entityConfigService: EntityConfigService,
        private readonly workflowService: WorkflowService,
        private readonly workflowConfigService: WorkflowConfigService,
        private readonly searchService: SearchService,
        private readonly dateCalcService: DateCalcService,
        private readonly eventService: EventService,
        private readonly adminService: AdminService,
        private readonly modalService: ModalService,
        private readonly aclService: AclService,
        private readonly adminConfigService: AdminConfigService) {
    }

    $onInit() {
        this.scope.$watch(() => [this.entityId, this.templatesTemplateId], (newValue, oldValue) => {
            if (newValue[0] && newValue[1]) {
                var split = Utils.IdBuilder.splitEntityID(newValue[0]);
                if (split.charTypeID == Consts.CharTypeIDs.property) {
                    this.showAssets = false;
                }
                this.parentRecordID = split.recID;
                this.charTypeID = split.charTypeID;

                this.getParentCatalogItems(this.entityId);
                this.StartSearch(this.entityId)
                    .then(() => {
                        let templateID: number;
                        let charTypeID: number;
                        if (isNaN(parseInt(this.templatesTemplateId))) {
                            let split = Utils.IdBuilder.splitTemplateID(this.templatesTemplateId);
                            templateID = split.templateID;
                            charTypeID = split.charTypeID;
                        } else {
                            templateID = parseInt(this.templatesTemplateId);
                            charTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;
                        }

                        // char type id override for relationships
                        if (this.templatesCharTypeId) {
                            charTypeID = this.templatesCharTypeId;
                        }
                        if (charTypeID > 0 && templateID > 0) {
                            this.loadAssociatedTemplates(charTypeID, templateID).then(() => {
                                this.getUsageTemplateAssociationList();
                            });
                        }
                    });
            }
        }, true);

        this.scope.$watch(() => this.forceRefresh, (newValue, oldValue) => {
            if (newValue && !oldValue) {
                this.usageRows = {};
                this.pivotRows = {};
                this.datesOrdered = {};
                this.dateTotals = {};
                this.forceRefresh = false;
                this.isBulkCreateMode = false;
                this.scope.$root.$broadcast(Consts.Events.RefreshPreviewEntity);
                this.StartSearch(this.entityId)
                    .then(() => {
                        if (this.refreshTableParent) {
                            this.refreshTableParent = false;
                            this.refreshParentDetails();
                        }
                    });
            }
        });

        this.scope.$watch(() => this.groupedSelectedAmounts, (newValue, oldValue) => {
            if (this.groupedSelectedAmounts && this.usageTableCollection) {
                this.selectedAmounts = [];

                // reset
                for (let tID in this.usageTableCollection.usageTableGroups) {
                    this.hasLockedAmountsSelected[tID] = false;
                    this.hasAmountAssociatedToAcctDocument[tID] = false;
                }

                var templatesWithSelectedAmounts: string[] = [];
                for (let usageID in this.groupedSelectedAmounts) {
                    let usage: Models.IUsageDocument;

                    for (let templateID in this.usageTableCollection.usageTableGroups) {
                        var usages = this.usageTableCollection.usageTableGroups[templateID].usages;

                        usage = _.find(usages, (u) => {
                            return u.document.entityID == usageID;
                        });

                        if (usage != undefined) {
                            this.hasLockedAmountsSelected[templateID] = this.hasLockedAmountsSelected[templateID] || _.any(this.groupedSelectedAmounts[usageID], (amt) => {
                                var amtLocked = false;
                                this.entityService.getEntityStatuses(Consts.CharTypeIDs.amount, [amt.recordID]).then((res) => {
                                    amtLocked = res[amt.recordID].lockIndicator == 1;
                                });
                                return amtLocked;
                            });

                            this.hasAmountAssociatedToAcctDocument[templateID] = this.hasAmountAssociatedToAcctDocument[templateID] || _.any(this.groupedSelectedAmounts[usageID], (amt) => {
                                return this.amountHasParentInvoice(amt);
                            });

                            break;
                        }
                    }

                    if (this.groupedSelectedAmounts[usageID].length > 0) {
                        // if not already recorded
                        if (templatesWithSelectedAmounts.indexOf(usage.document.templateID.toString()) === -1) {
                            templatesWithSelectedAmounts.push(usage.document.templateID.toString());
                        }
                        this.groupedSelectedAmounts[usageID].forEach((amt) => {
                            this.selectedAmounts.push(amt);
                        });
                    }
                }

                var statusIDs = _.chain(this.selectedAmounts).map((amt) => {
                    return amt.statusID;
                }).uniq().valueOf();

                if (statusIDs.length === 1) {
                    this.getWorkflowActions(Consts.CharTypeIDs.amount, this.selectedAmounts[0].templateID, statusIDs[0])
                        .then((response) => {
                            this.amountWorkflowActions = response;
                        });
                }

                this.usageTemplateHasSelectedAmounts = {};
                templatesWithSelectedAmounts.forEach((templateID) => {
                    this.usageTemplateHasSelectedAmounts[templateID] = true;
                })
            }
        }, true);

        this.scope.$watch(() => this.selectedUsages, (newValue, oldValue) => {
            for (var templateID in this.selectedUsages) {
                this.selectedUsageIDs[templateID] = this.selectedUsages[templateID].map((usage) => {
                    return usage.document.entityID;
                });

                if (newValue[templateID]) {
                    this.hasLockedRowsSelected[templateID] = _.any(this.selectedRows[templateID], (usage) => {
                        return usage.lockedIndicator;
                    });

                    var newLength = this.selectedUsages[templateID].length;
                    var oldLength = oldValue[templateID] ? oldValue[templateID].length : 0;
                    // if the selected items for this template changed
                    if (newLength != oldLength) {
                        var totalLength = this.usageTableCollection.usageTableGroups[templateID].usages.length;

                        // if allSelected is currently set but now not all are selected
                        if (this.allSelected[templateID] && newLength != totalLength) {
                            this.allSelected[templateID] = false;
                        }
                        // all are selected
                        else if (newLength == totalLength) {
                            this.allSelected[templateID] = true;
                        }
                    }
                }
            }
        }, true);

        this.scope.$watch(() => this.groupPages, (newValue, oldValue) => {
            for (var i in newValue) {
                var templateID = _.parseInt(i);

                if (oldValue[templateID]) {
                    if (newValue[templateID].page != oldValue[templateID].page || newValue[templateID].rowCount != oldValue[templateID].rowCount
                        || newValue[templateID].sortDir != oldValue[templateID].sortDir || newValue[templateID].sortField != oldValue[templateID].sortField) {
                        var groupPages = newValue[templateID];

                        this.GetUsagesByEntity(this.entityId, templateID, groupPages.page, groupPages.rowCount, groupPages.sortField == "title" ? "title_sort" : groupPages.sortField, groupPages.sortDir, this.getFilters(templateID), this.catalogItemKeywords[templateID]);
                    }
                }
            }
        }, true);

        this.scope.$watch(() => {
            if (this.entityId == null) {
                return null;
            } else {
                return this.entityId;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.GetUsagesByEntity(this.entityId)
                            .then(() => {
                            });;
                    });
                }
            });

        this.scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && newValue == "Done") {
                this.checkForRemovalOfCatalogItems();
                this.refreshParentDetails();
            }
        });

        this.scope.$watch(() => this.selectedRows, (newValue, oldValue) => {

            for (var i in this.selectedRows) {
                var templateID = _.parseInt(i);

                if (!oldValue[templateID] || this.selectedRows[templateID].length != oldValue[templateID].length) {
                    var recIDs = _.map(this.selectedRows[templateID], (row) => {
                        return row.recordID;
                    });

                    let existingSelectedUsageIDs = _.map(this.selectedUsages[templateID], (u) => {
                        return u.document.entityID;
                    });

                    let newSelectedUsages = _.filter(this.usageTableCollection.usageTableGroups[templateID].usages, (usage) => {
                        return recIDs.indexOf(usage.document.recordID) > -1 && existingSelectedUsageIDs.indexOf(usage.document.entityID) === -1;
                    });

                    this.selectedUsages[templateID] = this.selectedUsages[templateID] || [];

                    // if selectedRows does not contain this record, and this record is part of the current (not a previous page) dataset, remove it
                    _.remove(this.selectedUsages[templateID], (su) => {
                        return recIDs.indexOf(su.document.recordID) === -1 && this.usageTableCollection.usageTableGroups[templateID].usages.map((usage) => {
                            return usage.document.recordID;
                        }).indexOf(su.document.recordID) !== -1;
                    });

                    this.selectedUsages[templateID] = this.selectedUsages[templateID].concat(newSelectedUsages);

                    this.checkSelectedUsageStatuses(templateID);

                    if (oldValue[templateID]) {
                        if (this.allSelected[templateID] && oldValue[templateID].length > this.selectedRows[templateID].length) {
                            this.allSelected[templateID] = false;
                        }
                    }

                    // either way, the selected items changed so we need to check workflow if the unique statusID's changed
                    var oldStatusIDs: number[] = [];
                    if (oldValue[templateID]) {
                        oldStatusIDs = this.getUniqueStatuses(oldValue[templateID]);
                    }

                    var statusIDs = this.getUniqueStatuses(this.selectedRows[templateID]);

                    if (statusIDs.length === 1 && _.difference(statusIDs, oldStatusIDs).length > 0) {
                        // IIFE for the win. Variable hoisting is lame. I can has ES6 pls?
                        ((template) => {
                            this.getWorkflowActions(Consts.CharTypeIDs.usage, template, statusIDs[0])
                                .then((response) => {
                                    this.usageWorkflowActions[templateID] = response;
                                });
                        })(templateID);
                    }
                }
            }
            //send out event with current state of selected rows for an allocation template
            if (this.allocationTemplateID > 0) {
                this.$rootScope.$broadcast(Consts.Events.AllocationRowSelectionChanged, _.map(this.selectedRows[this.allocationTemplateID], r => r.entityID));
            }
        }, true);

        this.workflowConfigService.getProcessesWithSteps(Consts.CharTypeIDs.amount)
            .then((res) => {
                this.amountWorkflowConfig = res;
            });

        this.eventService.on(Consts.Events.RefreshTablesAndParents, () => {
            if (this.initialized) {
                this.refreshTableParent = true;
                this.forceRefresh = true;
            }
        });

        this.eventService.on(Consts.Events.RefreshTables, () => {
            if (this.initialized) {
                this.forceRefresh = true;
            }
        });

        this.scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            this.currentPreviewEntityID = data;
        });
    }

    private canDeleteResults: _.Dictionary<boolean> = {};
    private canEditResults: _.Dictionary<boolean> = {};


    amountHasParentInvoice(amt: Models.IEntitySearchDoc) {
        var hasParent = false;
        this.entityService.getEntityParentRelationship(amt.entityID, Consts.CharTypeIDs.invoice).then((res) => {
            hasParent = res.length > 0;
        });
        return hasParent;
    }

    FilterCatalogItems(event: JQueryKeyEventObject, templateID: number) {
        if (!event || event.keyCode === 13) {
            this.catalogSearchAction = true;
            var emptyUsageRow: Models.IUsageRow;
            this.filterTemplateIDAndUsagesHeaderRow[templateID] = emptyUsageRow;
            this.filterRemovedAll[templateID] = false;
            this.FilterEntities(templateID);
        }
    }

    ResetFilterCatalogItems(templateID: number) {
        this.catalogItemKeywords[templateID] = undefined;
        this.FilterEntities(templateID);
    }

    ToggleSelectAllUsages(templateID: number) {
        // unchecking
        if (this.allSelected[templateID]) {
            this.selectedRows[templateID] = [];
            this.selectedUsages[templateID] = [];
            this.allSelected[templateID] = false;
        } else {
            this.selectedRows[templateID] = this.selectedRows[templateID] || [];

            _.forEach(this.usageRows[templateID], (usage) => {
                this.selectedRows[templateID].push(usage);
            });
            this.allSelected[templateID] = true;
        }

        this.checkSelectedUsageStatuses(templateID);
    }

    private loadAssociatedTemplates(charTypeID: number, templateID: number) {
        return this.entityService.getAssociatedTemplatesDefaults(charTypeID,
            templateID, Consts.CharTypeIDs.usage, this.relCharTypeId, this.relChildCharTypeId)
            .then((templates) => {
                this.usageTemplateDefaults = templates;
                this.associatedTemplates = this.filterAssociatedTemplates(this.usageTemplateDefaults.associatedTemplates.filter(t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl)));

                var allocationTemplate = _.find(this.usageTemplateDefaults.associatedTemplates, (template) => template.systemIndicator === Consts.SystemIndicators.Allocation);
                this.allocationTemplateID = allocationTemplate ? allocationTemplate.templateID : 0;
                var canCalculateAllocation = allocationTemplate && Utils.AclUtil.hasCreateAccess(this.aclService.acls, allocationTemplate.acl) && this.showFinancials;

                var amortizationTemplate = _.find(this.usageTemplateDefaults.associatedTemplates, (template) => template.systemIndicator === Consts.SystemIndicators.Amortization);
                var canCalculateAmortization = allocationTemplate && amortizationTemplate && Utils.AclUtil.hasCreateAccess(this.aclService.acls, allocationTemplate.acl) && this.showFinancials;

                if (canCalculateAllocation) {
                    this.$rootScope.$broadcast(Consts.Events.CanCalculateAllocation, true);
                }

                if (canCalculateAmortization) {
                    this.$rootScope.$broadcast(Consts.Events.CanCalculateAmortization, true);
                }
            });
    }

    private filterAssociatedTemplates(templates: Models.ICharacteristicTemplate[]): Models.ICharacteristicTemplate[] {
        let filteredTemplates: Models.ICharacteristicTemplate[];
        if (this.templatesGroupId) {
            filteredTemplates = templates.filter(t => t.templateGroupID == this.templatesGroupId);
        } else {
            filteredTemplates = templates.filter(t => t.templateGroupID == Consts.TemplateGroupIDs.UsageModuleLevel);
        }

        const existingTemplateIDs: number[] = [];
        for (let templateID in this.usageRows) {
            if (this.usageRows[templateID].length > 0) {
                existingTemplateIDs.push(parseInt(templateID));
            }
        }

        if (existingTemplateIDs && existingTemplateIDs.length > 0) {
            filteredTemplates = filteredTemplates
                .filter(t => existingTemplateIDs.indexOf(t.templateID) == -1);
        }

        if (this.intersectionTemplates) {
            let templateIDs = this.intersectionTemplates.map((template) => { return template.templateID });
            filteredTemplates = _.filter(filteredTemplates, (template) => {
                return templateIDs.indexOf(template.templateID) > -1;
            });
        }

        if (this.showFinancials) {
            filteredTemplates = _.filter(filteredTemplates, (template) => {
                return _.contains(this.templatesAllowedOnFinancialTab, template.systemIndicator) || _.contains(this.templatesAllowedEverywhere, template.systemIndicator);
            });
        } else {
            filteredTemplates = _.filter(filteredTemplates, (template) => {
                return !_.contains(this.templatesAllowedOnFinancialTab, template.systemIndicator) || _.contains(this.templatesAllowedEverywhere, template.systemIndicator);
            });
        }

        return filteredTemplates;
    }

    private checkSelectedUsageStatuses(templateID: number) {
        if (this.selectedUsages[templateID] && this.selectedUsages[templateID].length > 0) {
            this.canBulkDelete[templateID] = true;
            _.forEach(this.selectedUsages[templateID], (usage: Models.IUsageDocument) => {
                if (this.canBulkDelete[templateID]) {
                    var step = _.find(this.usageTableCollection.templateWorkflowSteps[templateID], (step) => {
                        return step.stepID == usage.document.statusID;
                    });

                    if (!step.deleteIndicator) {
                        this.canBulkDelete[templateID] = false;
                    }

                    var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.usage, usage.document.templateGroupID, usage.document.templateID);
                    if (!Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl)) {
                        this.canBulkDelete[templateID] = false;
                    }
                }
            });
        } else {
            this.canBulkDelete[templateID] = false;
        }
    }

    LoadFilters(templateID: number) {
        var solrLabels: string[] = [];
        var templateName: string;

        this.usageTableCollection.usageTableGroups[templateID].usages.forEach((usage) => {
            templateName = usage.document.template;
            this.usageTableCollection.templateMetaData[templateID].characteristicMetaDatas.forEach((cmd) => {
                if ((cmd.charValueSetID || cmd.tagLabel == "entity_status" || cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date)
                    && cmd.dataTypeID != Consts.CharDataTypeIDs.CharDataTypes.money) {

                    solrLabels.push(Utils.CharUtil.GetCharSolrLabelByCmd(cmd));
                }
            });
        });

        var request = _.cloneDeep(this.searchModel);
        request.facetFields = solrLabels;
        request.rowCount = 0;
        request.template = `${templateName}|${templateID}`

        this.searchService.advancedSearch(request)
            .then((res) => {
                var fac = res.facetResults;
                this.filterValues[templateID] = {};
                this.selectedFilters[templateID] = {};
                this.tagLabelFilters[templateID] = {};

                for (var solrLabel in fac) {

                    if (fac[solrLabel].length > 0) {
                        this.filterValues[templateID][solrLabel] = [];

                        this.filterValues[templateID][solrLabel] = _.map(fac[solrLabel], (val) => {
                            return val.key;
                        });

                        this.usageTableCollection.templateMetaData[templateID].characteristicMetaDatas.forEach((cmd) => {
                            var sf = Utils.CharUtil.GetCharSolrLabelByCmd(cmd);

                            if (this.filterValues[templateID][sf]) {
                                if (!this.selectedFilters[templateID][sf]) {
                                    this.selectedFilters[templateID][sf] = {};
                                }

                                if (!this.tagLabelFilters[templateID][sf]) {
                                    this.tagLabelFilters[templateID][sf] = [];
                                }

                                this.filterValues[templateID][sf].forEach((val) => {
                                    this.selectedFilters[templateID][sf][val] = true;
                                    if (this.tagLabelFilters[templateID][sf].indexOf(val) === -1) {
                                        this.tagLabelFilters[templateID][sf].push(val);
                                    }
                                });

                                this.selectedFilters[templateID][sf]["NULL"] = true;
                                if (this.tagLabelFilters[templateID][sf].indexOf("NULL") === -1) {
                                    this.tagLabelFilters[templateID][sf].push("NULL");
                                }
                            }
                        });
                    }
                }
            });
    }

    StartSearch(entityID: string) {
        var deferred = this.$q.defer<void>();
        if (!this.templates || this.templates.length === 0) {
            this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.usage)
                .then((res) => {
                    this.templates = res;
                })
                .finally(() => {
                    this.GetUsagesByEntity(entityID).then(() => { deferred.resolve(); });
                });
        } else {
            if (this.bulkEditTemplateID > 0) {
                var groupPages = this.groupPages[this.bulkEditTemplateID];
                if (groupPages != null) {
                    this.GetUsagesByEntity(this.entityId, this.bulkEditTemplateID,
                        groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir,
                        this.getFilters(this.bulkEditTemplateID), this.catalogItemKeywords[this.bulkEditTemplateID])
                        .then(() => { deferred.resolve(); });
                }
                else {
                    this.GetUsagesByEntity(entityID).then(() => { deferred.resolve(); });
                }
            }
            else {
                this.GetUsagesByEntity(entityID).then(() => { deferred.resolve(); });
            }
        }

        return deferred.promise;
    }

    CopyDataDefaultSet(setID: string, entityID: any) {
        var id: number = -1;
        var charTypeID: number = -1;
        if (parseInt(entityID)) {
            id = entityID;
        } else {
            id = Utils.IdBuilder.splitEntityID(entityID).recID;
            charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
        }
        this.notifyService.startProgress();

        this.entityService.copyDataDefaultSet(setID, charTypeID, id, false)
            .then((result) => {
                this.refreshTableParent = true;
                this.forceRefresh = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    DeleteDataDefaultSet(setID: string) {
        this.notifyService.startProgress();

        this.entityService.deleteDataDefaultSet(setID)
            .then((res) => {
                var index = -1;
                for (var i = 0; i < this.usageTemplateDefaults.dataDefaultSets.length; i++) {
                    if (this.usageTemplateDefaults.dataDefaultSets[i].id == setID) {
                        index = i;
                        break;
                    }
                }

                if (index > -1) {
                    this.usageTemplateDefaults.dataDefaultSets.splice(index, 1);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    ToggleFiltering(templateID: number) {
        if (this.filtersEnabled[templateID]) {
            this.filtersEnabled[templateID] = false;
            this.filterRemovedAll[templateID] = false;
            this.selectedFilters = {};
            this.tagLabelFilters = {};
            var groupPages = this.groupPages[templateID];
            if (groupPages != undefined) {
                this.GetUsagesByEntity(this.entityId, templateID, groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir, undefined, this.catalogItemKeywords[templateID]);
            }
            else {
                this.GetUsagesByEntity(this.entityId, templateID, 1, 10, "table_sequence", 0, undefined, this.catalogItemKeywords[templateID]);
            }

        } else {
            this.filtersEnabled[templateID] = true;
            this.LoadFilters(templateID);
        }
    }

    public applyFilters(event: IOnApplyFiltersEvent) {
        let templateId = _.parseInt(event.groupName);
        this.selectedFilters[templateId][event.tagLabel] = event.selectedFilters;
        this.FilterEntities(templateId);
    }

    private getParentCatalogItems(parentEntityID: string) {
        this.searchService.advancedSearch({
            charTypeID: Consts.CharTypeIDs.property,
            relatedEntityID: parentEntityID,
            searchGroups: undefined,
            keywords: undefined,
            page: 1,
            rowCount: 100000,
            selectFields: ["title"]
        }).then((res) => {
            this.assets = res.documents.map((doc) => { return doc.title; });
        });
    }

    FilterFinancials(col: Models.IUsageTableCollection): Models.IUsageTableCollection {
        var filterFields = ['usageTableGroups', 'templateCharDataCollections', 'templateMetaData', 'templateWorkflowSteps'];

        Object.keys(col.templateMetaData).forEach(templateID => {
            var systemIndicator = col.templateMetaData[templateID].template.systemIndicator;

            if ((!this.showFinancials && _.contains(this.templatesAllowedOnFinancialTab, systemIndicator)) || (this.showFinancials && !_.contains(this.templatesAllowedOnFinancialTab, systemIndicator))) {
                if (_.contains(this.templatesAllowedEverywhere, systemIndicator)) return;

                filterFields.forEach(field => {
                    if (col && col[field] && col[field][templateID]) {
                        delete (col[field][templateID]);
                    }
                });
            }

        });

        return col;
    }

    GetUsagesByEntity(entityID: string, templateID?: number, page: number = 1, rowCount: number = 10, sortField: string = "table_sequence", sortDir: number = 0, filters?: _.Dictionary<string[]>, catalogItemKeywords?: string) {
        this.isLoading = true;
        var deferred = this.$q.defer<void>();
        this.notifyService.startProgress();
        this.searchModel.relatedEntityID = entityID;
        this.totalUsagesCnt = 0;
        if (templateID) {
            this.allSelected[templateID] = false;
        }
        else {
            this.bulkEditTemplateID = 0;
        }
        var usageRecIDs: number[] = [];

        //Have to change the case here to make sure solr sorting works correctly if this is the field
        if (sortField == "recordID") {
            sortField = "recordid";
        }

        this.usageService.getUsages(this.entityId, page, rowCount, filters, sortField, sortDir, catalogItemKeywords)
            .then((res) => {
                res = this.FilterFinancials(res);

                for (var i in res.amountTemplateMetaData) {
                    var tID = _.parseInt(i);

                    var amountTmd = res.amountTemplateMetaData[tID];
                    if (amountTmd.template.systemIndicator === Consts.SystemIndicators.AmortizedAmount) {
                        var feeChar = _.find(amountTmd.characteristicMetaDatas, char => char.systemIndicator === Consts.SystemIndicators.Amount.Amount);
                        if (feeChar) {
                            this.amortizationFeeTagLabel = feeChar.tagLabel + "_double";
                            break;
                        }
                    }
                }

                if (templateID) {
                    this.usageTableCollection.usageTableGroups[templateID] = res.usageTableGroups[templateID];

                    for (var assetID in res.assetTitles) {
                        this.usageTableCollection.assetTitles[assetID] = res.assetTitles[assetID];
                    }

                    for (var assetID in res.projectTitles) {
                        this.usageTableCollection.projectTitles[assetID] = res.projectTitles[assetID];
                    }

                    for (var assetID in res.contactTitles) {
                        this.usageTableCollection.contactTitles[assetID] = res.contactTitles[assetID];
                    }

                    for (var assetID in res.mockTitles) {
                        this.usageTableCollection.mockTitles[assetID] = res.mockTitles[assetID];
                    }

                    if (!this.usageTableCollection.usageTableGroups[templateID]) {
                        delete this.usageTableCollection.usageTableGroups[templateID];
                        delete this.groupPages[templateID];

                        if (this.catalogSearchAction) {
                            this.filterTemplateIDAndUsagesHeaderRow[templateID] = this.usageRows[templateID][0];
                        }
                    }
                }
                else {
                    this.usageTableCollection = res;
                }

                if (templateID) {
                    this.usageRows = this.usageRows || {};

                    if (catalogItemKeywords) {
                        this.usageRows[templateID] = [];
                    }
                    else {
                        delete this.usageRows[templateID];
                    }
                }

                ///~ setup groupPaging, usageHasAssets, check newly created usages
                for (var i in this.usageTableCollection.usageTableGroups) {
                    var tID = _.parseInt(i);

                    this.usageHasAssets[tID] = false;
                    this.usageHasProjects[tID] = false;
                    this.usageHasContacts[tID] = false;
                    this.usageHasMocks[tID] = false;

                    if (!this.amountTemplates[tID]) {
                        this.getAmountTemplates(tID);
                    }

                    if (!this.catalogTemplates[tID]) {
                        this.getAssociatedTemplates(Consts.CharTypeIDs.usage, tID, Consts.CharTypeIDs.property)
                            .then((res) => {
                                this.catalogTemplates[tID] = res;
                            });
                    }

                    var group = this.usageTableCollection.usageTableGroups[tID];

                    if (!this.groupPages[tID]) {
                        this.groupPages[tID] = { numFound: group.numFound, pageCount: Math.ceil(group.numFound / rowCount), page: page, rowCount: rowCount, sortDir: sortDir, sortField: sortField };
                    } else {
                        if (templateID > 0 && templateID == tID) {
                            this.groupPages[tID].numFound = group.numFound;
                            this.groupPages[tID].pageCount = Math.ceil(group.numFound / rowCount);
                            this.groupPages[tID].page = page;
                            this.groupPages[tID].rowCount = rowCount;
                        }
                        else {
                            if (this.groupPages[tID]) {
                                this.groupPages[tID].numFound = group.numFound;
                            }
                        }
                    }

                    this.totalUsagesCnt = this.totalUsagesCnt + group.numFound;

                    group.usages.forEach((usage) => {
                        usageRecIDs.push(usage.document.recordID);

                        if (_.keys(usage.assets).length == 0) {
                            usage.assets = undefined;
                        }

                        if (_.keys(usage.amounts).length == 0) {
                            usage.amounts = undefined;
                        }

                        if (!this.usageHasAssets[tID] && usage.assets) {
                            this.usageHasAssets[tID] = true;
                        }

                        if (!this.usageHasProjects[tID] && _.keys(usage.projects).length > 0) {
                            this.usageHasProjects[tID] = true;
                        }

                        if (!this.usageHasContacts[tID] && _.keys(usage.contacts).length > 0) {
                            this.usageHasContacts[tID] = true;
                        }

                        if (!this.usageHasMocks[tID] && _.keys(usage.mocks).length > 0) {
                            this.usageHasMocks[tID] = true;
                        }

                        _.forEach(this.newlyCreatedUsageEntityIds, (newUsageEntityID) => {
                            if (usage.document.entityID == newUsageEntityID) {
                                if (this.selectedUsages[tID] == null) {
                                    this.selectedUsages[tID] = [];
                                }
                                this.selectedUsages[tID].push(usage);
                            }
                        });
                    });

                    var templateMetaData = this.usageTableCollection.templateMetaData[tID];
                    var columns = this.$filter<IMetaDataFilter>("metaData")(templateMetaData, { groupId: -1, visibility: this.visibility });

                    if (_.any(templateMetaData.characteristicMetaDatas, cmd => cmd.tagLabel == 'last_updated')) {
                        if (!_.any(columns, c => c.tagLabel == "last_updated")) {
                            columns.push(_.find(templateMetaData.characteristicMetaDatas, cmd => cmd.tagLabel == 'last_updated'));
                        }
                    }

                    this.setupRows(this.usageTableCollection.usageTableGroups[tID].usages, columns);

                    if (this.selectedRows[tID] && this.selectedRows[tID].length > 0) {
                        this.resetSelectedUsages(tID);
                    }

                    if ((this.bulkCreatedAmountIDs && this.bulkCreatedAmountIDs.length > 0) || (this.selectedAmounts && this.selectedAmounts.length > 0)) {
                        this.resetSelectedAmounts(tID);
                    }
                }
            })
            .finally(() => {
                this.isLoading = false;
                this.initialized = true;
                var filterAppliedForTemplateIDAndNoResult = this.filterTemplateIDAndUsagesHeaderRow[templateID];
                if (!_.isEmpty(filterAppliedForTemplateIDAndNoResult)) {
                    if (_.isEmpty(this.usageRows[templateID])) {
                        this.usageRows[templateID] = [];
                        this.usageRows[templateID].push(filterAppliedForTemplateIDAndNoResult);
                        this.filterRemovedAll[templateID] = true;
                        //This is just a hack. To prevent from hiding no record found when template filter is applied but no result is returned
                        if (this.totalUsagesCnt == 0) {
                            this.totalUsagesCnt = 1;
                        }
                    }
                }
                this.newlyCreatedUsageEntityIds = []; // Clear this array as it is only required when they add new quick tables to just select the newly created usages
                this.catalogSearchAction = false; //Resetting catalog search action variable
                this.notifyService.endProgress();

                if (this.associatedTemplates) {
                    this.associatedTemplates = this.filterAssociatedTemplates(this.usageTemplateDefaults.associatedTemplates);
                }

                var parentCharTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;
                if (parentCharTypeID == Consts.CharTypeIDs.property) {
                    this.getUsageParentRecs(usageRecIDs)
                        .then(() => {
                            deferred.resolve();
                        });
                }
                else {
                    deferred.resolve();
                }
            });

        return deferred.promise;
    }

    private resetSelectedUsages(templateID: number) {
        let selectedIDs = _.map(this.selectedRows[templateID], (sr) => { return sr.entityID });

        let usageIDs = _.map(this.usageRows[templateID], (ur) => { return ur.entityID; });
        // remove newly returned usageID's so we can re-add the actual new objects below
        // I think we should look into having this all just use entityID's instead of the actual objects.
        _.remove(this.selectedRows[templateID], (sr) => {
            return usageIDs.indexOf(sr.entityID) > -1;
        });

        let newSelectedRows = _.filter(this.usageRows[templateID], (ur) => {
            return selectedIDs.indexOf(ur.entityID) > -1;
        });

        this.selectedRows[templateID] = newSelectedRows;
    }

    private resetSelectedAmounts(usageTemplateID: number) {
        let selectedIDs = _.map(this.selectedAmounts, (amt) => { return amt.entityID; });
        this.selectedAmounts = [];
        this.bulkCreatedAmountIDs = this.bulkCreatedAmountIDs || [];
        this.usageTableCollection.usageTableGroups[usageTemplateID].usages.forEach((ud) => {
            this.groupedSelectedAmounts[ud.document.entityID] = [];
            for (var relRecID in ud.amounts) {
                if (selectedIDs.indexOf(ud.amounts[relRecID].entityID) > -1 || this.bulkCreatedAmountIDs.indexOf(ud.amounts[relRecID].entityID) > -1) {
                    this.groupedSelectedAmounts[ud.document.entityID].push(ud.amounts[relRecID]);
                }
            }
        });

        this.bulkCreatedAmountIDs = undefined;
    }

    private setupRows(usages: Models.IUsageDocument[], columns: Models.ICharacteristicMetaData[]) {
        var templateID: number = usages[0].document.templateID;
        this.usageRows = this.usageRows || {};
        this.usageRows[templateID] = [];
        this.templateTotal[templateID] = {
            currency: usages[0].document.characteristics["currency_str"],
            amount: usages.reduce((acc, curr) => acc + curr.document.characteristics['fee_money_double'], 0)
        };

        usages.forEach((usage) => {
            var cols: Models.IListTableColumn[] = [];
            var isPivotable = this.usageTableCollection.templateMetaData[usage.document.templateID].template.systemIndicator === Consts.SystemIndicators.Amortization;

            columns.forEach((cmd) => {
                var solrLabel = Utils.CharUtil.GetCharSolrLabelByCmd(cmd);

                if (solrLabel == "recordid") {
                    //This is accurate for SOLR, but not for how we're retrieving data here. We need to change the chase of id to ID
                    solrLabel = "recordID";
                }

                var value = usage.document.characteristics[solrLabel] || usage.document[solrLabel];
                var formatter = Utils.CharUtil.GetFormatter(cmd.dataTypeID);

                //Check for the default Date Math TBD value of 09/09/1900
                //If we have that value, then we need to display "TBD" and not the date value
                if (value == "1900-09-09T00:00:00Z" || value == Consts.DateMath.BlankDateValue) {
                    value = "TBD";
                    formatter = Utils.CharUtil.GetFormatter(Consts.CharDataTypeIDs.CharDataTypes.alphanumeric);
                }
                else if (value == Consts.DateMath.PerpetutityDateValue) {
                    value = "Perpetuity";
                    formatter = Utils.CharUtil.GetFormatter(Consts.CharDataTypeIDs.CharDataTypes.alphanumeric);
                }
                //--

                if (solrLabel == 'last_updated_date') {
                    value = usage.document.lastUpdated;
                    formatter = 'dateLocal:"L"';
                }

                if (cmd.multipleIndicator == 1) {
                    value = _.unique(value);
                }
                //Check if characteristic is LOV bound and if it is an array and sort it if so
                if (cmd.charValueSetID != null && _.isArray(value)) {
                    value = _.sortBy(value);
                }
                cols.push({
                    label: cmd.label,
                    formatter: formatter,
                    // if this is money, we want to get the value using _str but sort by _double. This is an awful hack -ccrabb
                    solrLabel: cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money ? solrLabel.replace("_str", "_double") : solrLabel,
                    characteristicID: cmd.characteristicID,
                    dataTypeID: cmd.dataTypeID,
                    value: value,
                    multipleIndicator: cmd.multipleIndicator,
                    systemIndicatorID: cmd.systemIndicator
                });
            });

            var workflowStep = _.find(this.usageTableCollection.templateWorkflowSteps[templateID], (step) => {
                return step.stepID === usage.document.statusID;
            });

            var row: Models.IUsageRow = this.getUsageRow(usage, cols, workflowStep);

            if (usage.amounts) {
                row.amounts = [];
                _.forOwn(usage.amounts, (amount: Models.IEntitySearchDoc, relRecID) => {
                    row.amounts.push(amount);
                });

                row.amountNumFound = usage.usageAmountsNumFound;

                if (isPivotable) {
                    this.generatePivotRows(templateID, usage, row.amounts);
                    if (usage.usageAmountsNumFound > row.amounts.length) {
                        this.setupPivotRows(templateID, usage, row.amounts);
                    }
                } else {
                    if (usages.length === 1) {
                        this.expandedUsages[row.recordID] = row;
                    }
                }
            }
            _.forEach(usage.assets, x => {
                row.catalogItems[x] = this.usageTableCollection.assetTitles[x];
            });
            _.forEach(usage.projects, x => {
                row.projectItems[x] = this.usageTableCollection.projectTitles[x];
            });
            _.forEach(usage.contacts, x => {
                row.contactItems[x] = this.usageTableCollection.contactTitles[x];
            });
            _.forEach(usage.mocks, x => {
                row.mockItems[x] = this.usageTableCollection.mockTitles[x];
            });

            this.usageRows[templateID].push(row);
        });
    }

    private setupPivotRows(templateID: number, usage: Models.IUsageDocument, loadedAmounts: Models.IEntitySearchDoc[]) {
        return this.usageService.getUsageAmountDocuments(this.entityId, `d${usage.document.divisionID}c${Consts.CharTypeIDs.relationship}r${usage.relRecID}`, 0, usage.usageAmountsNumFound)
            .then(response => {
                var amounts = loadedAmounts;
                _.forEach(response.usageAmountDocuments, amount => {
                    if (!_.find(amounts, x => x.entityID === amount.entityID)) {
                        amounts.push(amount);
                    }
                });
                this.generatePivotRows(templateID, usage, amounts);
            });
    }

    private generatePivotRows(templateID: number, usage: Models.IUsageDocument, allAmounts: Models.IEntitySearchDoc[]) {
        if (!this.amortizationFeeTagLabel) return;

        if (!this.pivotRows[templateID]) {
            this.pivotRows[templateID] = {};
        }

        var ent = this.pivotRows[templateID][usage.relRecID];
        if (!ent) ent = {};

        if (!this.datesOrdered[templateID]) {
            this.datesOrdered[templateID] = [];
        }

        _.forEach(allAmounts, amount => {
            //Doing a check for null since not all amounts will have this date field
            if (amount.characteristics['due_date_date'] && amount.characteristics[this.amortizationFeeTagLabel]) {
                var parsedDate = this.parseDate(amount.characteristics['due_date_date']);

                var fee = amount.characteristics[this.amortizationFeeTagLabel];

                this.addAndSort(this.datesOrdered[templateID], parsedDate);

                if (!this.dateTotals[templateID]) this.dateTotals[templateID] = {};
                if (!this.dateTotals[templateID][parsedDate]) this.dateTotals[templateID][parsedDate] = 0;
                this.dateTotals[templateID][parsedDate] += fee;

                ent[parsedDate] = fee;
                this.pivotRows[templateID][usage.relRecID] = ent;
            }
        });

        var canPivot = this.canPivot(templateID);
        this.canTemplatePivot[templateID] = canPivot;
        if (canPivot && this.isTemplatePivoted[templateID] == null) {
            this.isTemplatePivoted[templateID] = true;
        }
    }

    private parseDate(d: string) {
        var year = d.substring(0, 4);
        var month = d.substring(5, 7);
        var day = d.substring(8, 10);
        return `${month}/${day}/${year}`; // TODO: Use moment for date parsing
    }

    private addAndSort(arr: string[], val: string) {
        if (arr.indexOf(val) >= 0) return;

        arr.push(val);
        var i = arr.length - 1;
        var item = arr[i];
        while (i > 0 && this.dateCompare(item, arr[i - 1])) {
            arr[i] = arr[i - 1];
            i -= 1;
        }
        arr[i] = item;
    }

    private dateCompare(a, b) {
        var aYear = a.substring(6, 10);
        var bYear = b.substring(6, 10);

        var aMonth = a.substring(0, 2);
        var bMonth = b.substring(0, 2);

        var aDay = a.substring(3, 5);
        var bDay = b.substring(3, 5);

        return (aYear < bYear) || (aYear === bYear && aMonth < bMonth) || (aYear === bYear && aMonth === bMonth && aDay < bDay);
    }

    private canPivot(templateID) {
        return !!this.pivotRows[templateID] && Object.keys(this.pivotRows[templateID]).length > 0;
    }

    ToggleTemplatePivot(templateID: number) {
        this.isTemplatePivoted[templateID] = !this.isTemplatePivoted[templateID];

        if (this.usageRows[templateID] && this.isTemplatePivoted[templateID]) {
            _.forEach(this.usageRows[templateID], row => {
                this.expandedUsages[row.recordID] = null;
            });
        }

        if (this.filtersEnabled[templateID] && this.isTemplatePivoted[templateID]) {
            this.ToggleFiltering(templateID);
        }
    }

    private getUsageRow(usage: Models.IUsageDocument, cols: Models.IListTableColumn[], workflowStep: Models.IWFStep): Models.IUsageRow {
        return {
            recordID: usage.document.recordID,
            recordRevisionID: usage.document.recordRevisionID,
            columns: cols,
            title: usage.document.title,
            currency: usage.document.characteristics["currency_str"] || "",
            catalogItems: {},
            projectItems: {},
            contactItems: {},
            mockItems: {},
            deleteIndicator: workflowStep ? workflowStep.deleteIndicator : null,
            activeIndicator: workflowStep ? workflowStep.activeIndicator : null,
            lockedIndicator: workflowStep ? workflowStep.lockIndicator : false,
            relRecID: usage.relRecID,
            entityID: usage.document.entityID,
            statusID: usage.document.statusID,
            templateID: usage.document.templateID,
            templateGroupID: usage.document.templateGroupID,
            sequenceNumber: usage.sequenceNumber
        };

        //TODO ^
    }

    private getFilters(templateID: number) {
        if (!this.selectedFilters[templateID]) {
            return {};
        }
        let filters = Object.keys(this.selectedFilters[templateID])
            .reduce<_.Dictionary<string[]>>(
                (result, tagLabel) => {
                    let allValues = Object.keys(this.selectedFilters[templateID][tagLabel])
                    let activeValues = allValues.filter(value => this.selectedFilters[templateID][tagLabel][value]);
                    if (allValues.length !== activeValues.length) {
                        result[tagLabel] = activeValues;
                    }
                    return result;
                }, {});
        return filters;
    }

    FilterEntities(templateID: number) {
        if (this.catalogItemKeywords) {
            var groupPages = this.groupPages[templateID];

            //If groupPages is null, then create a new one for this template.  This may be because of bulk delete or antoher action that cleared out the template specific instance of groupPages
            if (groupPages == null) {
                groupPages = { numFound: 10, pageCount: 1, page: 1, rowCount: 10, sortDir: 0, sortField: "table_sequence" };
            }

            if (this.catalogItemKeywords[templateID]) {
                if (groupPages.page != 1) {
                    groupPages.page = 1;
                }
                else {
                    this.GetUsagesByEntity(this.entityId, templateID, groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir, this.getFilters(templateID), this.catalogItemKeywords[templateID]);
                }
            } else {
                this.GetUsagesByEntity(this.entityId, templateID, groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir, this.getFilters(templateID), this.catalogItemKeywords[templateID]);
            }
        }
    }

    private getWorkflowActions(charTypeID: number, templateID: number, statusID: number) {
        return this.workflowService.getAvailableWorkflowActions(charTypeID, templateID, statusID);
    }

    private getUniqueStatuses(usages: Models.IUsageRow[]) {
        return _(usages)
            .map((usage) => {
                return usage.statusID;
            })
            .uniq()
            .valueOf();
    }

    GetCharSolrLabel(cmd: Models.ICharacteristicMetaData): string {
        return Utils.CharUtil.GetCharSolrLabelByCmd(cmd);
    }

    GetCharSolrSortLabel(cmd: Models.ICharacteristicMetaData): string {
        if (cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
            return cmd.tagLabel + "_str_sort";
        }
        return this.GetCharSolrLabel(cmd);
    }

    StartExecuteBulkWorkflow(charTypeID: number, templateID: number, workflowAction: Models.IWFAction) {
        var statusID: number;
        var recordIDTitlesDictionary: { [key: number]: string } = {};

        if (charTypeID == Consts.CharTypeIDs.usage) {
            let usages: Models.IUsageRow[] = [];
            this.selectedRows[templateID].forEach((usage) => {
                usages.push(usage);
            });

            var statusIDs = this.getUniqueStatuses(usages);
            if (usages.length > 0 && statusIDs.length > 1) {
                alert('You cannot execute a workflow on usages of varying statuses');
            } else {

                _.forEach(usages, (usage) => {
                    recordIDTitlesDictionary[usage.recordID] = usage.title;
                });

                statusID = statusIDs.pop();
            }
        } else if (charTypeID == Consts.CharTypeIDs.amount) {
            if (_.chain(this.selectedAmounts).map((amt) => { return amt.statusID }).uniq().valueOf().length > 1) {
                alert('You cannot execute a workflow on amounts of varying statuses');
            } else {
                var statusIDs = _(this.selectedAmounts)
                    .map((amount) => {
                        return amount.statusID;
                    })
                    .uniq()
                    .valueOf();

                statusID = statusIDs.pop();

                _.forEach(this.selectedAmounts, (amuont) => {
                    recordIDTitlesDictionary[amuont.recordID] = amuont.title;
                });
            }
        }

        var recordCount = _.keys(recordIDTitlesDictionary).length;

        if (recordCount > 0) {

            this.GetPreviewNotifications(workflowAction.processID, workflowAction.actionID)
                .then((result) => {
                    if (!_.isEmpty(result.notifications)) {
                        this.modalService.bulkExecuteWorkFlow(this.entityId, charTypeID, templateID, recordIDTitlesDictionary, workflowAction.processID, workflowAction.actionID, statusID)
                            .then((result) => {
                                if (result == undefined) {
                                    this.forceRefresh = true;
                                }
                                else {
                                    if (!_.isEmpty(result.jobID)) {
                                        var progressStatus: string = "";
                                        this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                            .then((jobProgressResult) => {
                                                if (jobProgressResult.status == "Done") {
                                                    if (charTypeID == Consts.CharTypeIDs.amount) {
                                                        this.refreshTableParent = true;
                                                    }
                                                    this.forceRefresh = true;
                                                }
                                            });
                                    }
                                }
                            });
                    }
                    else {
                        this.notifyService.startProgress();
                        this.workflowService.createBatchID()
                            .then((batchIDResult) => {
                                var batchID = batchIDResult.batchID;
                                var recordIDs = _.keys(recordIDTitlesDictionary).map(key => _.parseInt(key));
                                this.workflowService.executeWorkflowJob(charTypeID, recordIDs, workflowAction.actionID, workflowAction.processID, batchID)
                                    .then((result) => {
                                        this.notifyService.endProgress();
                                        var progressStatus: string = "";
                                        this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                            .then((jobProgressResult) => {
                                                if (jobProgressResult.status == "Done") {
                                                    if (charTypeID == Consts.CharTypeIDs.amount) {
                                                        this.refreshTableParent = true;
                                                    }
                                                    this.forceRefresh = true;
                                                }
                                            });
                                    });
                            });
                    }
                });

        }
    }

    GetPreviewNotifications(processID: number, actionID: number): ng.IPromise<any> {
        return this.workflowConfigService.getPreviewNotifications(processID, actionID);
    }

    private getAmountTemplates(templateID: number) {
        return this.getAssociatedTemplates(Consts.CharTypeIDs.usage, templateID, Consts.CharTypeIDs.amount)
            .then((templates) => {
                this.amountTemplates[templateID] = templates;
            });
    }

    private getAssociatedTemplates(parentCharTypeID: number, parentTemplateID: number, childCharTypeID: number) {
        var key = "pc" + parentCharTypeID + "pt" + parentTemplateID + "cc" + childCharTypeID;
        var deferred: ng.IDeferred<Models.ICharacteristicTemplate[]>;
        if (!this.deferrals[key]) {
            deferred = this.$q.defer<Models.ICharacteristicTemplate[]>();
            this.deferrals[key] = deferred;
        } else {
            deferred = this.deferrals[key];
        }
        var output = <Models.ICharacteristicTemplate[]>this.simpleCache.get(key);
        if (output == null) {
            this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, parentTemplateID, childCharTypeID)
                .then((result) => {
                    output = result.filter(ct => Utils.AclUtil.hasReadAccess(this.aclService.acls, ct.acl));
                    this.simpleCache.put(key, output);
                    this.deferrals[key].resolve(output);
                });
        } else {
            this.deferrals[key].resolve(output);
        }

        return this.deferrals[key].promise;
    }

    ViewUsage(usage: Models.IUsageRow) {
        var relRecID = this.usageParentRels[usage.recordID] || usage.relRecID;
        this.usageService.getUsage(usage.recordID, relRecID)
            .then((res) => {
                this.currentPreviewEntityID = usage.entityID;
                this.$rootScope.$broadcast(Consts.Events.ViewEntityRelationshipPair, res);
            });
    }

    DeleteUsage(usage: Models.IUsageRow) {
        if (this.$window.confirm("Are you sure you want to remove this usage?")) {
            var usageDoc = _.find(this.usageTableCollection.usageTableGroups[usage.templateID].usages, (us) => {
                return us.document.recordID == usage.recordID;
            });

            this.notifyService.startProgress();
            var transAssetRelID = Utils.IdBuilder.buildEntityID(usageDoc.document.divisionID, Consts.CharTypeIDs.relationship, usage.relRecID);
            this.removedComponentTriples = [];
            //check for catalog items that are children of this usage
            this.entityService.getEntityRelationships(transAssetRelID, Consts.CharTypeIDs.property)
                .then((result) => {
                    if (result.length > 0) {
                        _.forEach(result, (rel) => {
                            this.removedComponentTriples.push({ parentEntityID: this.entityId, removedComponentID: usageDoc.document.entityID, catalogItemID: Utils.IdBuilder.buildEntityID(usageDoc.document.divisionID, rel.childCharTypeID, rel.childRecID), catalogItemTitle: "" });
                        });
                    }
                })
                .finally(() => {
                    var associatedToInvoices = false;

                    var childRecIDs: number[] = [];
                    childRecIDs.push(usage.recordID);

                    this.usageService.getTablesWithAmountWithAccountingDocuments(this.charTypeID, this.parentRecordID, Consts.CharTypeIDs.usage, childRecIDs)
                        .then((result) => {
                            if (result.data.length > 0) {
                                associatedToInvoices = true;
                            }
                        }).finally(() => {
                            if (associatedToInvoices) {
                                this.$window.alert("Unable to delete this table row because there are one or more associated accounting records.");
                                this.notifyService.endProgress();
                                this.scope.$broadcast(Consts.Events.NotifyDone);
                            }
                            else {
                                this.usageService.deleteUsage(transAssetRelID)
                                    .then((result) => {
                                        var groupPages = this.groupPages[usage.templateID];
                                        _.remove(this.usageRows[usage.templateID], (usageRow) => {
                                            return usageRow.recordID == usage.recordID;
                                        });

                                        _.remove(this.usageTableCollection.usageTableGroups[usage.templateID].usages, (usageDoc) => {
                                            return usageDoc.document.recordID == usage.recordID;
                                        });

                                        this.GetUsagesByEntity(this.entityId, usage.templateID, groupPages.page,
                                            groupPages.rowCount, groupPages.sortField, groupPages.sortDir, this.getFilters(usage.templateID), this.catalogItemKeywords[usage.templateID]);

                                        _.remove(this.selectedUsages[usage.templateID], (u: Models.IUsageDocument) => u.relRecID == usage.relRecID);
                                    })
                                    .finally(() => {
                                        this.PromptRemoveOrphanedCatalogItems().then(() => {
                                            this.notifyService.endProgress();
                                            this.refreshParentDetails();
                                        });
                                    });
                            }
                        });
                });
        } else {
            this.scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    CopySuccessful(newEntityID: string) {
        this.refreshTableParent = true;
        this.forceRefresh = true;
    }

    CountVisibleChars(charDataCollection: Models.ICharDataCollection): number {
        if (charDataCollection != null) {
            return charDataCollection.templateMetaData.characteristicMetaDatas.length;
        }
        return 0;
    }

    StartEditUsage(usage: Models.IUsageRow) {
        this.notifyService.startProgress();
        var relRecID = this.usageParentRels[usage.recordID] || usage.relRecID;
        this.usageService.getUsage(usage.recordID, relRecID)
            .then((usage) => {
                if (this.CountVisibleChars(usage.charDataCollection) > 0) {
                    var usageAssetProjectRels: Models.IEntityRelationship[] = [];
                    usageAssetProjectRels = usage.assetRels.concat(usage.projectRels).concat(usage.contactRels).concat(usage.mockRels);
                    var sourceEntityID = this.usageParentRecs[usage.record.recordID];
                    var parent = sourceEntityID ? Utils.IdBuilder.buildEntityID(sourceEntityID.divID, sourceEntityID.charTypeID, sourceEntityID.recID) : this.entityId;
                    this.EditUsage(usage.charDataCollection, parent, Utils.IdBuilder.buildRelationshipID(usage.relationship), usageAssetProjectRels);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    EditUsage(charDataCollection: Models.ICharDataCollection, parentEntityID: string,
        idForRelationships: string, existingRelationships: Models.IEntityRelationship[]) {
        return this.modalService.editEntityWithRelationships(charDataCollection, parentEntityID, this.parentCurrencyCharData,
            existingRelationships, idForRelationships, [Consts.CharTypeIDs.user, Consts.CharTypeIDs.project, Consts.CharTypeIDs.property, Consts.CharTypeIDs.mock])
            .then((cdc) => {
                let templateID = charDataCollection.templateMetaData.templateID;
                let groupPages = this.groupPages[templateID];
                this.GetUsagesByEntity(this.entityId, templateID,
                    groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir,
                    this.getFilters(templateID), this.catalogItemKeywords[templateID]);
            })
            .catch((err) => {

            }).finally(() => {
                this.refreshParentDetails();
            });
    }

    NewAmount(usage: Models.IUsageRow, template: Models.ICharacteristicTemplate, event: ng.IAngularEvent) {
        const split = Utils.IdBuilder.splitEntityID(usage.entityID);
        let parentID = Utils.IdBuilder.buildEntityID(split.divID, Consts.CharTypeIDs.relationship, usage.relRecID);

        return this.entityService.getEntityCharData(usage.entityID)
            .then((res) => {
                return this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.amount).then((ctResult) => {
                    return this.modalService.createEntityByTemplate(Utils.IdBuilder.buildTemplateID(split.divID, Consts.CharTypeIDs.amount, template.templateID), parentID, this.parentCurrencyCharData, ctResult.map(i => i.charTypeID), false, res, true)
                        .then((result) => {
                            usage.amounts = usage.amounts || [];

                            return this.entityService.getEntityCharData(result.entityID)
                                .then((cdc) => {
                                    var document = Utils.CharUtil.CopyCharDataToEntityDocument(cdc, <Models.IEntitySearchDoc>{ characteristics: {} });
                                    var usageAmountDoc = <Models.IUsageAmountDocument>document;
                                    usageAmountDoc.invoiceRecID = 0;
                                    usageAmountDoc.lockedIndicator = cdc.status.lockIndicator;
                                    usageAmountDoc.deleteIndicator = cdc.status.deleteIndicator;
                                    usage.amounts.push(usageAmountDoc);

                                    var added = false;
                                    for (var templateID in this.usageTableCollection.usageTableGroups) {
                                        for (var i = 0; i < this.usageTableCollection.usageTableGroups[templateID].usages.length; i++) {
                                            var u = this.usageTableCollection.usageTableGroups[templateID].usages[i];
                                            if (u.document.entityID == usage.entityID) {
                                                u.amounts = u.amounts || {};
                                                u.amounts[result.relRecID] = usageAmountDoc;
                                                added = true;
                                                break;
                                            }
                                        }
                                        if (added) break;
                                    }

                                    this.refreshTableParent = true;
                                    this.forceRefresh = true;
                                });
                        });
                });
            });
    }

    NewUsageByTemplateID(templateID: number) {
        this.modalService.createEntity(Consts.CharTypeIDs.usage, templateID, this.entityId, this.parentCurrencyCharData,
            [Consts.CharTypeIDs.user, Consts.CharTypeIDs.project, Consts.CharTypeIDs.property, Consts.CharTypeIDs.mock])
            .then((entityID) => {
                this.forceRefresh = true;
            }).finally(() => {
                this.refreshParentDetails();
            });
    }

    PreMoveUsages(usages: Models.IUsageDocument[], templateID: number) {
        //Check for date math
        _.forEach(usages, (usage: Models.IUsageDocument) => {
            this.dateCalcService.checkEntityForDateMathRelationships(usage.document.entityID)
                .then((results) => {
                    if (results.length > 0) {
                        //This usage has date fields that are in someway tied to date math either through a parent or child relationship
                        _.forEach(results, (fieldName: string) => {
                            //We're not using the collection of dates that have date math right now, but let's keep it anyway
                            this.copyOrMoveDateMathWarning += fieldName + " ";
                        });
                    }
                });
        });

        this.LoadCharDataIDsAndNames();

        this.copyOrMoveUsageModalOpen = true;
        this.copyOrMoveModalTitle = "Move to";
        this.copyOrMoveSelectedUsages = usages;
        this.copyOrMoveChildCharTypeID = Consts.CharTypeIDs.usage;

        var entityID = this.entityId;
        var parentCharTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;

        if (parentCharTypeID == Consts.CharTypeIDs.relationship) {
            entityID = this.relEntityId;
            parentCharTypeID = Utils.IdBuilder.splitEntityID(this.relEntityId).charTypeID;
        }

        this.copyOrMoveParentEntityID = entityID;
        this.copyOrMoveParentCharTypeID = parentCharTypeID;
        this.copyOrMoveParentTemplateID = templateID;
        this.copyOrMoveTemplateGroupIDs.push(1);
        this.copyOrMoveTemplateGroupIDs.push(2);
    }

    MoveUsages() {
        var parentEntityIDs: string[] = [];
        var divID: number = Utils.IdBuilder.splitEntityID(this.entityId).divID;

        _.each(this.selectedRecIdTitlePairs, r => {
            var entityID: string = Utils.IdBuilder.buildEntityID(divID, this.copyOrMoveParentCharTypeID, r.key);
            if (!_.isUndefined(entityID) && entityID != this.entityId) {
                parentEntityIDs.push(entityID);
            }
        });

        if (parentEntityIDs.length > 0) {
            this.notifyService.startProgress();

            //There should only be 1 parent ID for a Move
            var newParentEntityID = parentEntityIDs[0];
            var promises: ng.IPromise<any>[] = [];
            this.removedComponentTriples = [];

            var orderedSelectedUsages = _.sortBy(this.copyOrMoveSelectedUsages, (usage) => usage.sequenceNumber);
            var usageRecIDs = orderedSelectedUsages.map(usage => usage.document.recordID);
            var action = 2;

            _.forEach(orderedSelectedUsages, (usage) => {
                if (usage.assets.length > 0) {
                    var relEntityID = Utils.IdBuilder.buildEntityID(usage.document.divisionID, Consts.CharTypeIDs.relationship, usage.relRecID);
                    promises.push(this.entityService.getEntityRelationships(relEntityID, Consts.CharTypeIDs.property)
                        .then((catalogRels) => {
                            if (catalogRels.length > 0) {
                                _.forEach(catalogRels, (catalogRel) => {
                                    var associatedCatalogEntityID = Utils.IdBuilder.buildEntityID(catalogRel.divisionID, catalogRel.childCharTypeID, catalogRel.childRecID);
                                    this.removedComponentTriples.push({ parentEntityID: this.entityId, removedComponentID: usage.document.entityID, catalogItemID: associatedCatalogEntityID, catalogItemTitle: "" });
                                });
                            }
                        }));
                }
            });

            this.$q.all(promises)
                .then(() => {
                    return this.usageService.copyToOrMoveToUsages(this.entityId, Consts.CharTypeIDs.usage, usageRecIDs, newParentEntityID, action)
                        .then((result) => {
                            this.copyOrMoveUsageModalOpen = false;
                            var progressStatus: string = "";
                            this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, true)
                                .then((jobProgressResult) => {
                                    if (jobProgressResult.status == "Done") {
                                        this.removeUsagesFromTable(this.copyOrMoveSelectedUsages);
                                        var cleanUpPromise = this.PromptRemoveOrphanedCatalogItems();

                                        return this.$q.all([cleanUpPromise]).then(() => {
                                            this.copyOrMoveUsageModalOpen = false;
                                            this.notifyService.notifySuccess("Move Successful");
                                            this.selectedRecIdTitlePairs = [];
                                            this.refreshParentDetails();
                                            this.notifyService.endProgress();
                                        });
                                    }
                                });
                        });
                });
        }
        else {
            this.copyOrMoveUsageModalOpen = false;
        }
    }

    PromptRemoveOrphanedCatalogItems(): ng.IPromise<any> {
        this.LoadCharDataIDsAndNames();

        var cleanUpPromises: ng.IPromise<any>[] = [];
        var parentEntityTitle = "";

        var promise1 = this.entityService.getEntityRecord(this.entityId)
            .then((result) => {
                parentEntityTitle = result.title;
            });

        cleanUpPromises.push(promise1);

        var childRecIDs = this.removedComponentTriples.map(c => Utils.IdBuilder.splitEntityID(c.catalogItemID).recID);

        cleanUpPromises.push(this.entityService.getChildNotExistingParentEntityRelationshipList(this.entityId, Consts.CharTypeIDs.property, childRecIDs)
            .then((results) => {
                this.orphanedCatalogItems = results.data;
            }));

        return this.$q.all(cleanUpPromises).then(() => {
            var uniqueTitles = _.uniq(_.map(this.orphanedCatalogItems, function (c) {
                return c.title;
            }));

            if (this.orphanedCatalogItems.length > 0) {
                var entityCharTypeID = Utils.IdBuilder.splitEntityID(this.entityId);

                if (entityCharTypeID.charTypeID != Consts.CharTypeIDs.relationship) {
                    this.deleteCatalogItemParentCharTypeName = this.GetCharDataName(entityCharTypeID.charTypeID);
                }

                var titleString = uniqueTitles.join('<br />'); //get a concatenated string of the Titles

                this.deleteCatalogItemEntityTitle = parentEntityTitle;
                this.deleteCatalogItemCatalogListText = titleString;

                this.deleteCatalogItemModalOpen = true;
            }
            else {
                this.PostRemoveOrphanedCatalogItems();
            }
        });

    }

    RemoveOrphanedCatalogItems() {
        this.notifyService.startProgress();
        if (this.orphanedCatalogItems.length > 0) {
            this.uniqueCatalogItemTemplates = [];
            this.uniqueCatalogItemTemplates = _.uniq(_.map(this.orphanedCatalogItems, function (entity) {
                return entity.templateID;
            }));

            if (this.uniqueCatalogItemTemplates.length > 0) {
                //Recursively delete the templates based on their order
                this.ProcessDelete()
                    .then((result) => {
                        this.showJobProgressStatus = true;
                        this.jobId = result.jobID;
                        this.jobTitle = result.jobTitle;
                        this.notifyService.endProgress();
                        this.jobType = "move";
                    });
            }
        }
    }

    ProcessDelete(): ng.IPromise<any> {
        var divID: number = Utils.IdBuilder.splitEntityID(this.entityId).divID;

        var uniqueCatalogItemIDs = _.uniq(_.map(this.orphanedCatalogItems, function (c) {
            return Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.property, c.recID);
        }));

        return this.usageService.deleteOrphanedCatalogItems(uniqueCatalogItemIDs, this.entityId);
    }

    PostRemoveOrphanedCatalogItems() {
        this.deleteCatalogItemModalOpen = false;
    }

    PreCopyUsages(usages: Models.IUsageDocument[], templateID: number) {
        //Check for date math
        _.forEach(usages, (usage: Models.IUsageDocument) => {
            this.dateCalcService.checkEntityForDateMathRelationships(usage.document.entityID)
                .then((results) => {
                    if (results.length > 0) {
                        //This usage has date fields that are in someway tied to date math either through a parent or child relationship
                        _.forEach(results, (fieldName: string) => {
                            //We're not using the collection of dates that have date math right now, but let's keep it anyway
                            this.copyOrMoveDateMathWarning += fieldName + " ";
                        });
                    }
                });
        });

        this.LoadCharDataIDsAndNames();

        this.copyOrMoveIsCopy = true;
        this.copyOrMoveUsageModalOpen = true;
        this.copyOrMoveModalTitle = "Copy to";
        this.copyOrMoveSelectedUsages = usages;
        this.copyOrMoveChildCharTypeID = Consts.CharTypeIDs.usage;

        var entityID = this.entityId;
        var parentCharTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;

        if (parentCharTypeID == Consts.CharTypeIDs.relationship) {
            entityID = this.relEntityId;
            parentCharTypeID = Utils.IdBuilder.splitEntityID(this.relEntityId).charTypeID;
        }

        this.copyOrMoveParentEntityID = entityID;
        this.copyOrMoveParentCharTypeID = parentCharTypeID;
        this.copyOrMoveParentTemplateID = templateID;
        this.copyOrMoveTemplateGroupIDs.push(1);
        this.copyOrMoveTemplateGroupIDs.push(2);
    }

    CopyUsages() {
        var parentEntityIDs: string[] = [];
        var divID: number = Utils.IdBuilder.splitEntityID(this.entityId).divID;

        _.each(this.selectedRecIdTitlePairs, r => {
            var entityID: string = Utils.IdBuilder.buildEntityID(divID, this.copyOrMoveParentCharTypeID, r.key);
            if (!_.isUndefined(entityID) && entityID != this.entityId) {
                parentEntityIDs.push(entityID);
            }
        });

        if (parentEntityIDs.length > 0) {
            this.notifyService.startProgress();

            //There should only be 1 parent ID for a Copy
            //This may change later to allow multiple parents
            var newParentEntityID = parentEntityIDs[0]
            var orderedSelectedUsages = _.sortBy(this.copyOrMoveSelectedUsages, (usage) => usage.sequenceNumber);
            var usageRecIDs = orderedSelectedUsages.map(usage => usage.document.recordID);
            var action = 1;

            this.usageService.copyToOrMoveToUsages(this.entityId, Consts.CharTypeIDs.usage, usageRecIDs, newParentEntityID, action)
                .then((result) => {
                    this.copyOrMoveUsageModalOpen = false;
                    var progressStatus: string = "";
                    this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, true)
                        .then((jobProgressResult) => {
                            if (jobProgressResult.status == "Done") {
                                this.notifyService.notifySuccess("Copy Successful");
                                this.selectedRecIdTitlePairs = [];
                                this.notifyService.endProgress();
                            }
                        });
                });
        }
        else {
            this.copyOrMoveUsageModalOpen = false;
        }
    }

    LoadCharDataIDsAndNames() {
        this.charDataIDsAndNames = [];

        return this.entityConfigService.getCharacteristicTypes()
            .then((results) => {
                this.charDataIDsAndNames = results;

                //We need to make sure this says Accounting and not Invoice
                var invoiceCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 7);
                invoiceCharType.charTypeName = "Accounting";
            })
    }

    GetCharDataName(charTypeID: number): string {
        if (charTypeID != null && this.charDataIDsAndNames.length > 0) {
            return _.find(this.charDataIDsAndNames, c => c.charTypeID == charTypeID).charTypeName;
        }
        else {
            return "";
        }
    }

    CreateBulkAmounts(templateID: string) {
        var modal = this.$uibModal.open({
            template: '<div><h1>Bulk Create Amounts</h1></div><rl-bulk-create-amounts usages="modalVM.usages" on-save="modalVM.Saved(entityIDs)" on-cancel="modalVM.Canceled()"></rl-bulk-create-amounts>',
            controller: BulkAmountsModalController,
            bindToController: true,
            controllerAs: 'modalVM',
            resolve: {
                usages: (): Models.IUsageRow[] => {
                    return this.selectedRows[templateID];
                }
            },
            size: 'xl'
        });

        modal.result.then((res) => {
            this.bulkCreatedAmountIDs = res;
            this.refreshTableParent = true;
            this.forceRefresh = true;
        });
    }

    BulkEditAmounts(templateID: number) {
        var bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {};
        const usages = this.usageTableCollection.usageTableGroups[templateID].usages;
        const amounts: Models.IEntitySearchDoc[] = [];
        var amtTemplateID = 0;
        var relatedChildCharTypeIDs: number[] = [];
        var catalogCharTypeID = Consts.CharTypeIDs.property;
        var projectCharTypeID = Consts.CharTypeIDs.project;
        var contactCharTypeID = Consts.CharTypeIDs.user;
        var bulkEditAmountParentRels: Models.IEntityRelationship[] = [];
        let usageAmountRelRecIDs: number[] = [];

        let usageAmountsTemplateIDs: number[] = [];

        usages.forEach((usage) => {
            if (this.groupedSelectedAmounts[usage.document.entityID]) {
                this.groupedSelectedAmounts[usage.document.entityID].forEach((amt) => {
                    amounts.push(amt);

                    if (usageAmountsTemplateIDs.indexOf(amt.templateID) == -1) {
                        usageAmountsTemplateIDs.push(amt.templateID);
                    }

                    for (let usageAmountRelRecID in usage.amounts) {
                        if (_.any(amounts, amt => amt.recordID == usage.amounts[usageAmountRelRecID].recordID)) {
                            usageAmountRelRecIDs.push(_.parseInt(usageAmountRelRecID));
                        }
                    }
                });
            }
        });

        if (usageAmountsTemplateIDs.length > 1) {
            alert("Bulk Edit can only be performed on records of the same Template.");
            return;
        }


        if (amounts.length == 0) return;

        let usageGroupedAmounts: { [usageID: string]: string[] } = {};

        this.usageTableCollection.usageTableGroups[templateID].usages.forEach((usage) => {
            bulkEditRelationshipTitles[usage.document.entityID] = {};
            var usageCatalogItems: Models.IEntityRecIDTitle[] = [];
            _.forOwn(usage.assets, (recID: number, relRecID) => {
                var usageCatalogItem: Models.IEntityRecIDTitle = {
                    recID: recID,
                    title: this.usageTableCollection.assetTitles[recID]
                };
                usageCatalogItems.push(usageCatalogItem);
            });
            bulkEditRelationshipTitles[usage.document.entityID][catalogCharTypeID] = usageCatalogItems;

            var usageProjects: Models.IEntityRecIDTitle[] = [];
            _.forOwn(usage.projects, (recID: number, relRecID) => {
                var usageProject: Models.IEntityRecIDTitle = {
                    recID: recID,
                    title: this.usageTableCollection.projectTitles[recID]
                };
                usageProjects.push(usageProject);
            });
            bulkEditRelationshipTitles[usage.document.entityID][projectCharTypeID] = usageProjects;

            var usageContacts: Models.IEntityRecIDTitle[] = [];
            _.forOwn(usage.projects, (recID: number, relRecID) => {
                var usageContact: Models.IEntityRecIDTitle = {
                    recID: recID,
                    title: this.usageTableCollection.contactTitles[recID]
                };
                usageContacts.push(usageContact);
            });
            bulkEditRelationshipTitles[usage.document.entityID][contactCharTypeID] = usageContacts;

            _.forEach(this.groupedSelectedAmounts[usage.document.entityID], (usageAmt) => {
                if (!usageGroupedAmounts[usage.document.entityID]) {
                    usageGroupedAmounts[usage.document.entityID] = [];
                }
                usageGroupedAmounts[usage.document.entityID].push(usageAmt.entityID);
            });
        });

        if (this.usageTableCollection.assetTitles) {
            if (!_.any(relatedChildCharTypeIDs, c => c == catalogCharTypeID)) {
                relatedChildCharTypeIDs.push(catalogCharTypeID);
            }
        }

        if (this.usageTableCollection.projectTitles) {
            if (!_.any(relatedChildCharTypeIDs, c => c == projectCharTypeID)) {
                relatedChildCharTypeIDs.push(projectCharTypeID);
            }
        }

        if (this.usageTableCollection.contactTitles) {
            if (!_.any(relatedChildCharTypeIDs, c => c == contactCharTypeID)) {
                relatedChildCharTypeIDs.push(contactCharTypeID);
            }
        }

        let promises: ng.IPromise<void>[] = [];
        var bulkGroupedEntityCharDataCollections: { [usageID: string]: Models.ICharDataCollection[] } = {};
        this.notifyService.startProgress();
        let bulkCharData: { [usageID: string]: Models.ICharDataCollection[] } = {};

        let usageRelRecIDs: { [usageID: string]: string } = {};


        for (let usageID in usageGroupedAmounts) {
            bulkCharData[usageID] = [];
            usageGroupedAmounts[usageID].forEach((amtID) => {
                bulkGroupedEntityCharDataCollections[usageID] = [];
                promises.push(this.entityService.getEntityCharData(amtID)
                    .then((res) => {
                        bulkCharData[usageID].push(res);
                        amtTemplateID = res.templateMetaData.templateID;
                        var amtRecID = Utils.IdBuilder.splitEntityID(res.entityID).recID;
                        var amountCatalogItems: Models.IEntityRecIDTitle[] = [];
                        if (this.amountCatalogRels[amtRecID] != undefined) {
                            amountCatalogItems.push(this.amountCatalogRels[amtRecID]);
                            bulkEditRelationshipTitles[res.entityID] = {};
                            bulkEditRelationshipTitles[res.entityID][catalogCharTypeID] = amountCatalogItems;
                        }
                    }));
            });
            var usage = _.find(usages, u => u.document.entityID == usageID);
            usageRelRecIDs[usageID] = Utils.IdBuilder.buildEntityID(usage.document.divisionID, Consts.CharTypeIDs.relationship, usage.relRecID);
        }

        var request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.relationship,
            recordIDs: usageAmountRelRecIDs.join(","),
            rowCount: usageAmountRelRecIDs.length
        }

        if (request.recordIDs.length > 0) {
            promises.push(this.entityService.getRecordDocumentsForRecordIDs(request)
                .then((result) => {
                    _.forEach(result.documents, (doc) => {
                        var bulkEditAmountParentRel: Models.IEntityRelationship = {
                            divisionID: doc.divisionID,
                            parentRecID: doc.characteristics["parentrecordid"],
                            parentCharTypeID: doc.characteristics["parentchartypeid"],
                            childCharTypeID: doc.characteristics["childchartypeid"],
                            childRecID: doc.characteristics["childrecordid"],
                            level: doc.characteristics["rellevel"],
                            relRecID: doc.characteristics["relrecid"],
                            relTypeID: doc.characteristics["reltypeid"],
                            relIndicatorID: doc.characteristics["relind"],
                            sequenceNumber: doc.characteristics["sequencenumber"]
                        };
                        bulkEditAmountParentRels.push(bulkEditAmountParentRel);
                    });
                }));
        }

        var configuredRelatedCharTypeIDs: { [charTypeID: number]: boolean } = {};

        promises.push(this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.amount, usageAmountsTemplateIDs[0], Consts.CharTypeIDs.property)
            .then((result) => {
                configuredRelatedCharTypeIDs[Consts.CharTypeIDs.property] = result.length > 0 ? true : false;
            }));

        this.$q.all(promises)
            .then(() => {
                // keep ordering
                for (var usageID in usageGroupedAmounts) {
                    var amounts = usageGroupedAmounts[usageID];
                    var bulkData = bulkCharData[usageID];
                    amounts.forEach((amtID) => {
                        var amt = _.find(bulkData, (a) => {
                            return a.entityID == amtID;
                        });
                        bulkGroupedEntityCharDataCollections[usageID].push(amt);
                    });
                }

                var divID = Utils.IdBuilder.splitEntityID(this.entityId).divID;
                this.notifyService.endProgress();

                this.modalService.bulkEdit(this.entityId, bulkGroupedEntityCharDataCollections, divID, Consts.CharTypeIDs.amount, amtTemplateID,
                    this.parentCurrencyCharData, bulkEditRelationshipTitles, false, bulkEditAmountParentRels, relatedChildCharTypeIDs, this.amountCatalogRelationships, "", 0, usageRelRecIDs, configuredRelatedCharTypeIDs)
                    .then((result) => {

                        if (!_.isEmpty(result.jobID)) {
                            var progressStatus: string = "";
                            this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                .then((jobProgressResult) => {
                                    if (jobProgressResult.status == "Done") {
                                        this.forceRefresh = true;
                                    }
                                });
                        }
                    });
            });
    }

    BulkEdit(templateID: number) {
        var bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {};
        var promises: ng.IPromise<void>[] = [];
        var bulkGroupedEntityCharDataCollections: { [usageID: string]: Models.ICharDataCollection[] } = {};
        var bulkEditUsageRels: { [usageEntityID: string]: Models.IEntityRelationship[] } = {};
        var bulkEditUsageParentRels: Models.IEntityRelationship[] = [];
        var relatedChildCharTypeIDs: number[] = [];

        let usageRelRecDict: _.Dictionary<number> = {};
        this.selectedRows[templateID].forEach((doc, index) => {

            if (doc) {
                usageRelRecDict[doc.recordID] = doc.relRecID;
                bulkEditRelationshipTitles[doc.entityID] = {};
                var usageCatalogItems: Models.IEntityRecIDTitle[] = [];
                _.forOwn(doc.catalogItems, (value: string, key) => {
                    var usageCatalogItem: Models.IEntityRecIDTitle = {
                        recID: _.parseInt(key),
                        title: value
                    };
                    usageCatalogItems.push(usageCatalogItem);
                });
                bulkEditRelationshipTitles[doc.entityID][Consts.CharTypeIDs.property] = usageCatalogItems;

                var usageProjects: Models.IEntityRecIDTitle[] = [];
                _.forOwn(doc.projectItems, (value: string, key) => {
                    var usageProject: Models.IEntityRecIDTitle = {
                        recID: _.parseInt(key),
                        title: value
                    };
                    usageProjects.push(usageProject);
                });
                bulkEditRelationshipTitles[doc.entityID][Consts.CharTypeIDs.project] = usageProjects;

                var usageContacts: Models.IEntityRecIDTitle[] = [];
                _.forOwn(doc.contactItems, (value: string, key) => {
                    var usageContact: Models.IEntityRecIDTitle = {
                        recID: _.parseInt(key),
                        title: value
                    };
                    usageContacts.push(usageContact);
                });
                bulkEditRelationshipTitles[doc.entityID][Consts.CharTypeIDs.user] = usageContacts;

                var mocks: number[] = [];
                var usageMocks: Models.IEntityRecIDTitle[] = [];
                _.forOwn(doc.mockItems, (value: string, key) => {
                    var usageMock: Models.IEntityRecIDTitle = {
                        recID: _.parseInt(key),
                        title: value
                    };
                    usageMocks.push(usageMock);
                });
                bulkEditRelationshipTitles[doc.entityID][Consts.CharTypeIDs.mock] = usageMocks;
            }
        });

        this.notifyService.startProgress();
        promises.push(this.usageService.getBulkUsages(usageRelRecDict)
            .then((usages) => {
                bulkGroupedEntityCharDataCollections[this.entityId] = [];
                this.notifyService.endProgress();
                _.forEach(usages, (usage, index) => {
                    bulkGroupedEntityCharDataCollections[this.entityId][index] = usage.charDataCollection;
                    var allUsageRels: Models.IEntityRelationship[] = [];
                    allUsageRels = allUsageRels.concat(usage.assetRels).concat(usage.projectRels).concat(usage.contactRels).concat(usage.mockRels);
                    bulkEditUsageRels[usage.record.id] = allUsageRels;
                    bulkEditUsageParentRels.push(usage.relationship);
                });
            }));

        promises.push(this.entityConfigService.getCharTypeTemplateCharTypeAssociationList(Consts.CharTypeIDs.usage, templateID)
            .then((result) => {

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.property)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.property);
                }

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.user)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.user);
                }

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.project)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.project);
                }

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.mock)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.mock);
                }
            }));

        this.$q.all(promises)
            .finally(() => {
                this.bulkEditTemplateID = templateID;
                var divID = Utils.IdBuilder.splitEntityID(this.entityId).divID;
                var bulkEditSortField = this.groupPages[templateID].sortField;
                var bulkEditSortDir = this.groupPages[templateID].sortDir;
                this.refreshTableParent = true;
                this.notifyService.endProgress();

                this.modalService.bulkEdit(this.entityId, bulkGroupedEntityCharDataCollections, divID, Consts.CharTypeIDs.usage, this.bulkEditTemplateID,
                    this.parentCurrencyCharData, bulkEditRelationshipTitles, false, bulkEditUsageParentRels, relatedChildCharTypeIDs, bulkEditUsageRels, bulkEditSortField, bulkEditSortDir, {}, {})
                    .then((result) => {
                        if (!_.isEmpty(result.jobID)) {
                            var progressStatus: string = "";
                            this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                .then((jobProgressResult) => {
                                    if (jobProgressResult.status == "Done") {
                                        this.forceRefresh = true;
                                    }
                                });
                        }
                    });
            });
    }

    BulkEditCatalogItems(templateID: number) {
        this.bulkExistingRelationships = [];
        this.bulkUsageData = [];
        const promises = [];
        this.selectedUsages[templateID].forEach(usage => {
            promises.push(this.usageService.getUsage(usage.document.recordID, usage.relRecID));
        });

        this.$q.all(promises).then(result => {
            result.forEach(res => {
                this.bulkUsageData = this.bulkUsageData.concat(<Models.IUsageRelationshipPair>res);
                this.bulkExistingRelationships = this.bulkExistingRelationships.concat((<Models.IUsageRelationshipPair>res).assetRels);
            });

            this.bulkEditAssociationsModalOpen = true;
            this.bulkUsagesTemplateID = templateID;
        });
    }

    SaveBulkCatalogItems() {
        var confirmMessage = `Are you sure you want to ${BulkAssociationMode[this.bulkCatalogAssociationMode]} Catalog Items for ${this.selectedUsages[this.bulkUsagesTemplateID].length} Table rows?`;

        if (this.$window.confirm(confirmMessage)) {
            var selectedCatalogItemIDs = _.map(this.bulkCatalogItems, (ci) => { return ci.recordID; });

            var divID = this.selectedUsages[this.bulkUsagesTemplateID][0].document.divisionID;
            let deleteRelationshipIDs: string[] = [];
            let addRelationships: Models.IEntityRelationship[] = [];

            this.selectedUsages[this.bulkUsagesTemplateID].forEach((usage) => {
                let foundUsages = _.filter(this.bulkExistingRelationships, (rightRelPair) => {
                    return usage.assets && usage.assets[rightRelPair.relRecID];
                });

                if (this.bulkCatalogAssociationMode == BulkAssociationMode.Remove || this.bulkCatalogAssociationMode == BulkAssociationMode.Replace) {
                    var removeEntities: Models.IEntityRelationship[];
                    if (this.bulkCatalogAssociationMode == BulkAssociationMode.Remove) {
                        removeEntities = _.filter(foundUsages, (rel) => {
                            return selectedCatalogItemIDs.indexOf(rel.childRecID) > -1;
                        });
                    }
                    else {
                        removeEntities = _.filter(foundUsages, (rel) => {
                            return selectedCatalogItemIDs.indexOf(rel.childRecID) == -1;
                        });
                    }

                    if (removeEntities.length > 0) {
                        removeEntities.forEach((rm) => {
                            deleteRelationshipIDs.push(Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.relationship, rm.relRecID));
                        });
                    }
                }

                if (this.bulkCatalogAssociationMode == BulkAssociationMode.Add || this.bulkCatalogAssociationMode == BulkAssociationMode.Replace) {
                    var addedEntities = _.filter(selectedCatalogItemIDs, (ci) => {
                        return !_.any(foundUsages, (ar) => {
                            return ar.childRecID == ci;
                        });
                    });

                    if (addedEntities.length > 0) {
                        addedEntities.forEach((ae) => {
                            addRelationships.push({
                                divisionID: divID,
                                parentRecID: usage.relRecID,
                                parentCharTypeID: Consts.CharTypeIDs.relationship,
                                childCharTypeID: Consts.CharTypeIDs.property,
                                childRecID: ae,
                                sequenceNumber: undefined
                            });
                        });
                    }
                }
            });

            this.notifyService.startProgress();
            this.entityService.bulkUpdateRelationships(addRelationships, deleteRelationshipIDs)
                .then(() => {
                    this.notifyService.endProgress();
                    this.bulkEditAssociationsModalOpen = false;
                    this.bulkCatalogAssociationMode = BulkAssociationMode.Replace;
                    var groupPages = this.groupPages[this.bulkUsagesTemplateID];
                    this.GetUsagesByEntity(this.entityId, this.bulkUsagesTemplateID, groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir, this.getFilters(this.bulkUsagesTemplateID), this.catalogItemKeywords[this.bulkUsagesTemplateID]);
                })
                .catch(() => {
                    this.notifyService.endProgress();
                    this.bulkEditAssociationsModalOpen = false;
                    this.bulkCatalogAssociationMode = BulkAssociationMode.Replace;
                    this.$window.alert("Sorry, an error has occurred.");
                });
        }
        else {
            // to re-enable the rl-busy-button
            this.scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    DeselectUsage(entityID: string) {
        _.remove(this.selectedRows[this.bulkUsagesTemplateID], (r) => {
            return r.entityID === entityID;
        });
    }

    removeUsagesFromTable(usages: Models.IUsageDocument[]) {
        var usageCopy = _.cloneDeep(usages);
        var tID = _.first(usageCopy).document.templateID;
        var currentNumFound = this.groupPages[tID].numFound;
        var newCount = currentNumFound - usages.length;
        var rowCount = this.groupPages[tID].rowCount;

        this.groupPages[tID].numFound = newCount;
        this.groupPages[tID].pageCount = Math.ceil((newCount) / rowCount);
        this.groupPages[tID].page = 1;
        this.groupPages[tID].rowCount = rowCount;

        usageCopy.forEach((usage, index) => {
            if (usage != null) {
                _.remove(this.usageRows[tID], (usageRow) => {
                    return usageRow.recordID == usage.document.recordID;
                });

                _.remove(this.usageTableCollection.usageTableGroups[tID].usages, (usageDoc) => {
                    return usageDoc.document.recordID == usage.document.recordID;
                });

                _.remove(this.selectedUsages[tID], (u: Models.IUsageDocument) => u.relRecID == usage.relRecID);
            }
        });
    }

    BulkDelete(templateID: number) {
        if (this.$window.confirm("Are you sure you want to delete the selected row(s)?")) {
            var bulkDeleteUsages = this.selectedUsages[templateID];
            if (bulkDeleteUsages.length > 0) {
                this.notifyService.startProgress();
                var promises: ng.IPromise<any>[] = [];
                var associatedToInvoices = false;

                var usageIDs: number[] = _.map(bulkDeleteUsages, (u) => {
                    return u.document.recordID;
                });

                this.usageService.getTablesWithAmountWithAccountingDocuments(this.charTypeID, this.parentRecordID, Consts.CharTypeIDs.usage, usageIDs)
                    .then((result) => {
                        if (result.data.length > 0) {
                            associatedToInvoices = true;
                        }
                    }).finally(() => {
                        if (associatedToInvoices) {
                            this.$window.alert("Unable to bulk delete selected table rows because there are one or more associated accounting records.");
                            this.notifyService.endProgress();
                            this.scope.$broadcast(Consts.Events.NotifyDone);
                        }
                        else {
                            var promises: ng.IPromise<any>[] = [];
                            this.removedComponentTriples = [];

                            _.forEach(bulkDeleteUsages, (usage) => {
                                var relEntityID = Utils.IdBuilder.buildEntityID(usage.document.divisionID, Consts.CharTypeIDs.relationship, usage.relRecID);
                                promises.push(this.entityService.getEntityRelationships(relEntityID, Consts.CharTypeIDs.property)
                                    .then((result) => {
                                        if (result.length > 0) {
                                            _.forEach(result, (rel) => {
                                                this.removedComponentTriples.push({ parentEntityID: this.entityId, removedComponentID: usage.document.entityID, catalogItemID: Utils.IdBuilder.buildEntityID(usage.document.divisionID, rel.childCharTypeID, rel.childRecID), catalogItemTitle: "" });
                                            });
                                        }
                                    }));
                            });

                            this.usageService.bulkDeleteUsages(this.entityId, usageIDs)
                                .then((result) => {

                                    this.$q.all(promises)
                                        .then(() => {
                                            this.jobTemplateID = bulkDeleteUsages[0].document.templateID;
                                            this.showJobProgressStatus = true;
                                            this.jobId = result.jobID;
                                            this.jobTitle = result.jobTitle;
                                            this.jobType = "bulk-delete";

                                            this.bulkDeleteTemplateID = bulkDeleteUsages[0].document.templateID;
                                            this.bulkDeleteGroupPages = this.groupPages[bulkDeleteUsages[0].document.templateID];

                                            this.removeUsagesFromTable(bulkDeleteUsages);
                                            this.refreshParentDetails();
                                            this.notifyService.endProgress();
                                        });
                                });
                        }
                    });


            }
        } else {
            this.scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    PostJobCleanup() {
        if (this.jobType === "move") {
            this.$window.location.assign("/Go/" + this.entityId);
        } else if (this.jobType === "bulk-delete") {
            this.PostBulkDelete();
        }
        else if (this.jobType === "workflow") {
            this.PostWorkflowAction();
        }
    }

    PostBulkDelete() {
        this.showJobProgressStatus = false;
        this.GetUsagesByEntity(this.entityId, this.bulkDeleteTemplateID, this.bulkDeleteGroupPages.page,
            this.bulkDeleteGroupPages.rowCount, this.bulkDeleteGroupPages.sortField, this.bulkDeleteGroupPages.sortDir, this.getFilters(this.bulkDeleteTemplateID), this.catalogItemKeywords[this.bulkDeleteTemplateID]);
    }

    PostWorkflowAction() {
        this.selectedRows[this.workflowTemplateID] = [];
        this.notifyService.endProgress();
        var groupPages = this.groupPages[this.workflowTemplateID];
        this.GetUsagesByEntity(this.entityId, this.workflowTemplateID, groupPages.page, groupPages.rowCount, groupPages.sortField, groupPages.sortDir, this.getFilters(this.workflowTemplateID), this.catalogItemKeywords[this.workflowTemplateID]);
    }

    checkForRemovalOfCatalogItems() {
        this.PromptRemoveOrphanedCatalogItems();
    }

    ExportCSV($event: ng.IAngularEvent, templateID: number) {
        $event.preventDefault();
        this.notifyService.startProgress();
        var filters = this.getFilters(templateID)
        this.usageService.exportUsagesCSV(this.entityId, templateID, filters)
            .then((result) => {
                this.csvExportJobID = result.jobID;
                this.StartCSVExportProgress();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    StartCSVExportProgress() {
        this.notifyService.startProgress();
        this.csvExportProgressIntervalPromise = this.$interval(() => this.UpdateCSVExportProgress(), 2000);
    }

    UpdateCSVExportProgress() {
        this.adminService.getJobState(this.csvExportJobID).then((result) => {
            if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                this.$interval.cancel(this.csvExportProgressIntervalPromise);
                if (result.status == "Done") {
                    this.$window.location.assign(result.resultMessage);
                }
                this.notifyService.endProgress();
            }
        });
    }

    OpenBulkCreateModal(templateID: number) {

        this.getAssociatedTemplates(Consts.CharTypeIDs.usage, templateID, Consts.CharTypeIDs.property)
            .then((res) => {
                this.catalogTemplates[templateID] = res;
                this.bulkCreateTemplateID = templateID;
                if (this.catalogTemplates[this.bulkCreateTemplateID].length == 0) {
                    this.bulkCreateAction = BulkCreateAction.Number;
                }
                this.bulkTableCreateOpen = true;
            });
    }

    StartCreateUsage() {
        this.bulkTableCreateOpen = false;
        this.selectCatalogItemsForBulkTableCreateOptionOpen = false;

        if (this.bulkCreateAction == BulkCreateAction.Number) {
            if (this.bulkCreateNumber === 1) {
                this.NewUsageByTemplateID(this.bulkCreateTemplateID);
            } else {
                this.startBulkCreate(this.bulkCreateTemplateID, this.bulkCreateNumber, this.bulkCreateAction);
            }
        } else if (this.bulkCreateAction == BulkCreateAction.CatalogItems) {
            this.startBulkCreate(this.bulkCreateTemplateID, 0, this.bulkCreateAction);
        }
        else if (this.bulkCreateAction == BulkCreateAction.SelectedCatalogItems) {
            this.selectedRelatedCatalogItemsForBulkCreateUsage = {};
            this.selectCatalogItemsForBulkTableCreateOptionOpen = true;
        }
    }

    StartCreateUsagesForSelectedCatalogITems() {
        this.selectCatalogItemsForBulkTableCreateOptionOpen = false;
        if (this.selectedRelatedCatalogItemsForBulkCreateUsage[Consts.CharTypeIDs.property].length > 0) {
            this.setupBulkCreate(this.bulkCreateTemplateID, 0, this.bulkCreateAction);
        }
        else {
            alert("Cannot create bulk usages");
        }
    }

    private startBulkCreate(templateID: number, count: number, action: BulkCreateAction) {
        this.setupBulkCreate(templateID, count, action);
    }

    // MOVE TO MODAL SERVICE
    private setupBulkCreate(templateID: number, count: number, action: BulkCreateAction) {
        var bulkGroupedEntityCharDataCollections: { [usageID: string]: Models.ICharDataCollection[] } = {};
        var bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {};
        var bulkEditUsageRels: { [usageEntityID: string]: Models.IEntityRelationship[] } = {};
        var bulkEditUsageParentRels: Models.IEntityRelationship[] = [];
        var relatedChildCharTypeIDs: number[] = [];
        var catalogCharTypeID = Consts.CharTypeIDs.property;
        var split = Utils.IdBuilder.splitEntityID(this.entityId);
        var templateEntityID = Utils.IdBuilder.buildTemplateID(split.divID, Consts.CharTypeIDs.usage, templateID);

        var charDataCollection: Models.ICharDataCollection;
        this.notifyService.startProgress();
        var entityPromise = this.usageService.getEmptyEntityCharData(templateEntityID)
            .then((res) => {
                charDataCollection = res;
            });

        var assetPromise: ng.IPromise<void>;
        var relationships: Models.IRecordRelationshipPair[];
        var tableCatalogConfigurationPromise: ng.IPromise<void>;
        var tableCatalogConfigTemplates: Models.ICharacteristicTemplate[] = [];

        if (action == BulkCreateAction.CatalogItems) {
            relatedChildCharTypeIDs.push(catalogCharTypeID);
            assetPromise = this.entityService.getRelatedRecords(this.entityId, Consts.CharTypeIDs.property)
                .then((res) => {
                    relationships = res;
                });

            tableCatalogConfigurationPromise = this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.usage, templateID, catalogCharTypeID)
                .then((result) => {
                    tableCatalogConfigTemplates = result;
                });
        }

        var usageTemplateHasCatalogorContactOrProjectAssociatedPromise = this.entityConfigService.getCharTypeTemplateCharTypeAssociationList(Consts.CharTypeIDs.usage, templateID)
            .then((result) => {
                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.property)) {
                    if (!_.any(relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.property)) {
                        relatedChildCharTypeIDs.push(Consts.CharTypeIDs.property);
                    }
                }

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.user)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.user);
                }

                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.project)) {
                    relatedChildCharTypeIDs.push(Consts.CharTypeIDs.project);
                }
            });

        this.$q.all([entityPromise, assetPromise, tableCatalogConfigurationPromise, usageTemplateHasCatalogorContactOrProjectAssociatedPromise])
            .then(() => {
                var rowCount = count;

                if (tableCatalogConfigTemplates.length > 0) {
                    relationships = _.filter(relationships, (rel) => {
                        if (_.any(tableCatalogConfigTemplates, c => c.templateID == rel.record.templateID && rel.relationship.relIndicatorID == Consts.RelationshipIndicator.Default)) {
                            return rel;
                        }
                    });
                } else {
                    relationships = [];
                }

                if (action == BulkCreateAction.CatalogItems) {
                    if (relationships && relationships.length > 0) {
                        rowCount = relationships.length;

                        for (var i = 0; i < relationships.length; i++) {
                            var rec = relationships[i].record;
                            var entityId = Utils.IdBuilder.buildEntityID(split.divID, Consts.CharTypeIDs.usage, i * -1);
                            bulkEditRelationshipTitles[entityId] = {};
                            var usageCatalogItems: Models.IEntityRecIDTitle[] = [];
                            var usageCatalogItem: Models.IEntityRecIDTitle = {
                                recID: rec.recordID,
                                title: rec.title
                            };
                            usageCatalogItems.push(usageCatalogItem);
                            bulkEditRelationshipTitles[entityId][catalogCharTypeID] = usageCatalogItems;
                        }
                    }
                } else if (action == BulkCreateAction.SelectedCatalogItems) {
                    if (!_.any(relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.property)) {
                        relatedChildCharTypeIDs.push(Consts.CharTypeIDs.property);
                    }
                    rowCount = this.selectedRelatedCatalogItemsForBulkCreateUsage[Consts.CharTypeIDs.property].length;
                    var allSelectedCatalogItems = this.selectedRelatedCatalogItemsForBulkCreateUsage[Consts.CharTypeIDs.property];
                    for (var i = 0; i < allSelectedCatalogItems.length; i++) {
                        var entityId = Utils.IdBuilder.buildEntityID(split.divID, Consts.CharTypeIDs.usage, i * -1);
                        bulkEditRelationshipTitles[entityId] = {};
                        var usageCatalogItems: Models.IEntityRecIDTitle[] = [];
                        var usageCatalogItem: Models.IEntityRecIDTitle = {
                            recID: allSelectedCatalogItems[i].recordID,
                            title: allSelectedCatalogItems[i].title
                        };
                        usageCatalogItems.push(usageCatalogItem);
                        bulkEditRelationshipTitles[entityId][catalogCharTypeID] = usageCatalogItems;
                    }
                }

                bulkGroupedEntityCharDataCollections[this.entityId] = [];
                for (var i = 0; i < rowCount; i++) {
                    var clone = _.cloneDeep(charDataCollection);
                    clone.entityID = Utils.IdBuilder.buildEntityID(split.divID, Consts.CharTypeIDs.usage, i * -1);
                    bulkGroupedEntityCharDataCollections[this.entityId][i] = clone;
                }

                var bulkEditSortField = this.groupPages[templateID] ? this.groupPages[templateID].sortField : undefined;
                var bulkEditSortDir = this.groupPages[templateID] ? this.groupPages[templateID].sortDir : undefined;
                this.isBulkCreateMode = true;
                this.bulkEditTemplateID = templateID;
                this.refreshTableParent = true;
                var divID = Utils.IdBuilder.splitEntityID(this.entityId).divID;
                this.notifyService.endProgress();

                this.modalService.bulkEdit(this.entityId, bulkGroupedEntityCharDataCollections, divID, Consts.CharTypeIDs.usage, templateID,
                    this.parentCurrencyCharData, bulkEditRelationshipTitles, true, bulkEditUsageParentRels, relatedChildCharTypeIDs, bulkEditUsageRels, bulkEditSortField, bulkEditSortDir, {}, {})
                    .then((result) => {
                        if (!_.isEmpty(result.jobID)) {
                            var progressStatus: string = "";
                            this.bulkCreateAction == BulkCreateAction.Number;
                            this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, true)
                                .then((jobProgressResult) => {
                                    if (jobProgressResult.status == "Done") {
                                        this.forceRefresh = true;
                                    }
                                });
                        }
                    });
            });
    }

    refreshParentDetails() {
        var parentEntityID: Models.IEntityID = Utils.IdBuilder.splitEntityID(this.entityId);
        if (parentEntityID.charTypeID == Consts.CharTypeIDs.transaction) {
            this.$rootScope.$broadcast(Consts.Events.RefreshDealDetails, this.entityId);
        }
    }

    // MOVE TO MODAL SERVICE
    // Associate to Invoice
    selectedAmountTemplates: Models.ICharacteristicTemplate[];
    selectedAmountCurrencyIDs: number[];
    isAmountProcessing: boolean = false;
    associateAmountsModalOpen: boolean;
    associateInvoiceTemplates: Models.ICharacteristicTemplate[];
    associatedInvoices: Models.IEntity[];
    showAccountingButton: boolean = false;

    StartAssociateToInvoice() {
        let selectedAmountTemplates: Models.ICharacteristicTemplate[] = [];
        let selectedAmountMoneyCharCurrencyIDs: number[] = [];
        let promises = [];
        let selectedAmountsEntityCharDataPairs: Models.IEntityCharDataPair[] = [];
        let validCurrencyListOfValues: string[] = [];
        let selectedAmountMoneyCharCurrencySymbols: string[] = [];


        this.selectedAmounts.forEach((amt) => {
            promises.push(this.entityService.getEntity(amt.entityID)
                .then((entity) => {
                    selectedAmountsEntityCharDataPairs.push(entity);
                }));
        });

        promises.push(this.adminConfigService.getCompanyCurrency().then((result) => {
            if (!_.isEmpty(result.data)) {
                validCurrencyListOfValues.push(result.data);
            }
        }));

        promises.push(this.adminConfigService.getCurrencyConversionList(false).then((result) => {
            if (result.length > 0) {
                _.forEach(result, r => {
                    validCurrencyListOfValues.push(r.transactionCurrency);
                });
            }
        }));

        this.$q.all(promises)
            .then(() => {

                var hasValidationError: boolean = false;
                var checkForValidCurrency: boolean = false;

                _.forEach(selectedAmountsEntityCharDataPairs, (entityCharDataPair) => {
                    selectedAmountTemplates.push(entityCharDataPair.charDataCollection.templateMetaData.template);

                    var amountCharMD = _.find(entityCharDataPair.charDataCollection.templateMetaData.characteristicMetaDatas, chr => chr.systemIndicator == Consts.SystemIndicators.Amount.Amount);
                    if (amountCharMD.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
                        var moneyCharDataValue = _.find(entityCharDataPair.charDataCollection.charDatas[amountCharMD.tagLabel], (char) => char.value != null);

                        if (moneyCharDataValue != null) {
                            checkForValidCurrency = true;
                            var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(moneyCharDataValue.value, {});
                            if (!_.isEmpty(moneyValue)) {
                                selectedAmountMoneyCharCurrencyIDs.push(moneyValue.locCur);
                                selectedAmountMoneyCharCurrencySymbols.push(moneyValue.locSym);
                            }
                            else {
                                var alertMessage = "Unable to associate amount with ID " + entityCharDataPair.record.recordID + " with no valid currency.";
                                this.$window.alert(alertMessage);
                                hasValidationError = true;
                                return;
                            }
                        }
                        else {
                            checkForValidCurrency = false;
                        }
                    }
                    else {
                        var currencyCharMD = _.find(entityCharDataPair.charDataCollection.templateMetaData.characteristicMetaDatas, chr => chr.systemIndicator == Consts.SystemIndicators.Amount.Currency);
                        var currencyCharDataValue = _.find(entityCharDataPair.charDataCollection.charDatas[currencyCharMD.tagLabel], (char) => char.value != null);

                        if (currencyCharDataValue != null) {
                            selectedAmountMoneyCharCurrencyIDs.push(currencyCharDataValue.valueID);
                            selectedAmountMoneyCharCurrencySymbols.push(currencyCharDataValue.value);
                        }
                        else {
                            var alertMessage = "Unable to associate amount with ID " + entityCharDataPair.record.recordID + " with no valid currency.";
                            this.$window.alert(alertMessage);
                            hasValidationError = true;
                            return;
                        }
                    }

                });

                this.selectedAmountTemplates = selectedAmountTemplates;
                this.selectedAmountCurrencyIDs = selectedAmountMoneyCharCurrencyIDs;
                var amountTemplateIDs = selectedAmountTemplates.map((template) => template.templateID);

                var uniqueCurrencySymbols = _.uniq(selectedAmountMoneyCharCurrencyIDs);
                if (uniqueCurrencySymbols.length > 1) {
                    this.$window.alert("Unable to associate amounts of different currencies to a single document.");
                    hasValidationError = true;
                    return;
                }

                if (checkForValidCurrency && !_.any(validCurrencyListOfValues, cur => cur == selectedAmountMoneyCharCurrencySymbols[0])) {
                    this.$window.alert("Unable to associate amounts of invalid currencies to a single document.");
                    hasValidationError = true;
                    return;
                }

                if (!hasValidationError) {
                    var split = Utils.IdBuilder.splitEntityID(this.entityId);

                    if (split.charTypeID > 0) {
                        this.notifyService.startProgress();
                        this.getAssociableInvoices(this.entityId, amountTemplateIDs, _.first(uniqueCurrencySymbols))
                            .then((result) => {
                                this.associatedInvoices = result.invoices;
                                this.associateInvoiceTemplates = result.templates.filter(t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                                this.associateAmountsModalOpen = true;
                            },
                                () => {
                                    this.notifyService.notifyError("Error getting invoice information");
                                })
                            .finally(() => {
                                this.notifyService.endProgress();
                            });
                    } else if (this.temporaryContractRecId && this.temporaryContractRecId > 0) {
                        this.notifyService.startProgress();
                        this.getAssociableContractInvoices(this.temporaryContractRecId, amountTemplateIDs, _.first(uniqueCurrencySymbols))
                            .then((result) => {
                                this.associatedInvoices = result.invoices;
                                this.associateInvoiceTemplates = result.templates.filter(t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                                this.associateAmountsModalOpen = true;
                            },
                                () => {
                                    this.notifyService.notifyError("Error getting invoice information");
                                })
                            .finally(() => {
                                this.notifyService.endProgress();
                            });
                    }
                    else {
                        this.notifyService.notifyError('Error loading invoices');
                    }
                }
            });
    }

    private getAssociableInvoices(entityID: string, amountTemplateIDs: number[], currencySymbol: number) {
        return this.usageService.getAssociableInvoices(this.entityId, amountTemplateIDs, currencySymbol);
    }

    // Hopefully temporary
    private getAssociableContractInvoices(recID: number, amountTemplateIDs: number[], currencySymbol: number) {
        return this.contractService.getAssociableInvoices(recID, amountTemplateIDs, currencySymbol);
    }

    AssocToInvoice(invoice: Models.IEntity, $event: ng.IAngularEvent) {
        $event.preventDefault();
        var amountIds = this.selectedAmounts.map((amount) => amount.recordID);
        this.notifyService.startProgress();
        this.isAmountProcessing = true;
        this.usageService.associateAmountsToInvoice(invoice.recordID, amountIds)
            .then(() => {
                this.notifyService.notifySuccess("Amounts associated");
                this.forceRefresh = true;
            }, () => {
                this.notifyService.notifyError("Error associating Amounts");
                return this.$q.reject();
            })
            .then(() => {
                this.associateAmountsModalOpen = false;
                this.forceRefresh = true;
            },
                angular.noop)
            .finally(() => {
                this.groupedSelectedAmounts = {};
                this.isAmountProcessing = false;
                this.notifyService.endProgress();
            });
    }

    StartAssocToNewInvoice(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        $event.preventDefault();

        var split = Utils.IdBuilder.splitEntityID(this.entityId);

        if (split.charTypeID > 0) {
            this.assocToNewInvoice(template);
        } else if (this.temporaryContractRecId && this.temporaryContractRecId > 0) {
            this.assocToNewContractInvoice(template);
        }
        else {
            this.notifyService.notifyError('Error Creating New Invoice');
        }
    }

    private assocToNewInvoice(template: Models.ICharacteristicTemplate) {
        var amountIds = this.selectedAmounts.map((amount) => amount.recordID);
        this.notifyService.startProgress();
        this.isAmountProcessing = true;
        this.usageService.associateAmountsToNewInvoice(this.entityId, template.templateID, amountIds)
            .then((result) => {
                if (result.success) {
                    this.$window.open(`/Go/${result.entityID}`, "_blank");
                } else {
                    this.notifyService.notifyError("Error associating Invoice");
                }
            })
            .finally(() => {
                this.forceRefresh = true;
                this.associateAmountsModalOpen = false;
                this.isAmountProcessing = false;
                this.groupedSelectedAmounts = {};
                this.notifyService.endProgress();
            });
    }

    // TEMPORARY
    private assocToNewContractInvoice(template: Models.ICharacteristicTemplate) {
        var amountIds = this.selectedAmounts.map((amount) => amount.recordID);
        var contractRecID = this.temporaryContractRecId;
        this.notifyService.startProgress();
        this.isAmountProcessing = true;
        this.contractService.associateAmountsToNewInvoice(contractRecID, template.templateID, amountIds)
            .then((result) => {
                if (result.success) {
                    this.$window.open(`/Go/${result.entityID}`, "_blank");
                    //this.$window.location.href = "/Go/" + result.entityID;
                } else {
                    this.notifyService.notifyError("Error associating Invoice");
                }
            })
            .finally(() => {
                this.forceRefresh = true;
                this.associateAmountsModalOpen = false;
                this.isAmountProcessing = false;
                this.groupedSelectedAmounts = {};
                this.notifyService.endProgress();
            });
    }

    //Drag and drop
    UpdateUsageOrder(event) {
        //This is the updated list of usages
        var newOrderList: Models.IUsageRow[] = event.dest.sortableScope.modelValue;

        var templateID = event.dest.sortableScope.$parent.$parent.template.templateID;

        var usagesRecIDAndSequence: { [recID: number]: number } = {};

        var newSequenceNumber = -1;

        if (event.dest.index == 0) {
            //If we're at the beginning of the list, get the next sequence number and / 2
            newSequenceNumber = _.ceil(newOrderList[event.dest.index + 1].sequenceNumber / 2);
        }
        else if (event.dest.index + 1 == newOrderList.length) {
            //If we're at the end of the list, get the previous sequence number and add 4096
            newSequenceNumber = newOrderList[event.dest.index - 1].sequenceNumber + 4096;
        }
        else {
            //Get the destination index + 1 so we can calculate the new sequence number
            var itemBeforeIndex = newOrderList[event.dest.index - 1].sequenceNumber;
            var itemAfterIndex = newOrderList[event.dest.index + 1].sequenceNumber;

            newSequenceNumber = _.ceil((itemBeforeIndex + itemAfterIndex) / 2);
        }

        var recordID = newOrderList[event.dest.index].recordID;

        _.first(_.filter(this.usageRows[templateID], u => u.recordID == recordID)).sequenceNumber = newSequenceNumber;

        usagesRecIDAndSequence[recordID] = newSequenceNumber;

        this.entityService.setRecordOrder(this.entityId, Consts.CharTypeIDs.usage, usagesRecIDAndSequence);
    };

    CanDelete(usage: Models.IUsageRow) {
        if (usage != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.usage, usage.templateGroupID, usage.templateID);
            if (this.canDeleteResults[acl] == null) {
                this.canDeleteResults[acl] = Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl);
            }
            return this.canDeleteResults[acl];
        }
    }

    CanEdit(usage: Models.IUsageRow) {
        if (usage != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.usage, usage.templateGroupID, usage.templateID);
            if (this.canEditResults[acl] == null) {
                this.canEditResults[acl] = Utils.AclUtil.hasWriteAccess(this.aclService.acls, acl);
            }
            return this.canEditResults[acl];
        }
    }

    private getUsageParentRecs(usageRecIDs: number[]) {
        return this.searchService.getRelatedParentRecords(Consts.CharTypeIDs.job, Consts.CharTypeIDs.usage, usageRecIDs)
            .then((result) => {
                if (result.success) {
                    var allUsageParentRecs = result.data;
                    _.forEach(allUsageParentRecs, (r) => {
                        var usageRecID = r.characteristics['childrecordid'];
                        var usageParentEntityID = r.characteristics['parentid'];
                        this.usageParentRecs[usageRecID] = Utils.IdBuilder.splitEntityID(usageParentEntityID);
                        this.usageParentRels[usageRecID] = r.recordID;
                    });
                }
            });
    }

    private getUsageTemplateAssociationList() {
        var promises = [];
        _.forEach(this.templates, (t) => {
            promises.push(this.entityConfigService.getCharTypeTemplateCharTypeAssociationList(Consts.CharTypeIDs.usage, t.templateID).then((result) => {
                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.property
                    || c.childCharTypeID == Consts.CharTypeIDs.project
                    || c.childCharTypeID == Consts.CharTypeIDs.user
                    || c.childCharTypeID == Consts.CharTypeIDs.mock)) {
                    this.usageTemplateHasCatalogOrProjectOrContactOrMockRelConfigured[t.templateID] = true;
                }
                else {
                    this.usageTemplateHasCatalogOrProjectOrContactOrMockRelConfigured[t.templateID] = false;
                }
            }));
        });

        return this.$q.all(promises);
    }

    UpdateComponentSequence($event: ng.IAngularEvent, templateID: number, templateGroupID: number, sortByCharTypeID: number) {
        $event.preventDefault();
        this.notifyService.startProgress();
        this.entityService.updateComponentSequence(this.charTypeID, this.parentRecordID, templateID, templateGroupID, Consts.CharTypeIDs.usage, sortByCharTypeID)
            .then((result) => {
                this.forceRefresh = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }
}